
      var $parcel$global = globalThis;
    // Import Auth0 at the very top (for bundling)
function $c5aa5a6035c47210$var$e(e, t) {
    var o = {};
    for(var n in e)Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (o[n] = e[n]);
    if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
        var i = 0;
        for(n = Object.getOwnPropertySymbols(e); i < n.length; i++)t.indexOf(n[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[i]) && (o[n[i]] = e[n[i]]);
    }
    return o;
}
"function" == typeof SuppressedError && SuppressedError;
var $c5aa5a6035c47210$var$t = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof window ? window : "undefined" != typeof $parcel$global ? $parcel$global : "undefined" != typeof self ? self : {};
function $c5aa5a6035c47210$var$o(e) {
    return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
function $c5aa5a6035c47210$var$n(e, t) {
    return e(t = {
        exports: {}
    }, t.exports), t.exports;
}
var $c5aa5a6035c47210$var$i = $c5aa5a6035c47210$var$n(function(e, t) {
    Object.defineProperty(t, "__esModule", {
        value: !0
    });
    var o = function() {
        function e() {
            var e = this;
            this.locked = new Map, this.addToLocked = function(t, o) {
                var n = e.locked.get(t);
                void 0 === n ? void 0 === o ? e.locked.set(t, []) : e.locked.set(t, [
                    o
                ]) : void 0 !== o && (n.unshift(o), e.locked.set(t, n));
            }, this.isLocked = function(t) {
                return e.locked.has(t);
            }, this.lock = function(t) {
                return new Promise(function(o, n) {
                    e.isLocked(t) ? e.addToLocked(t, o) : (e.addToLocked(t), o());
                });
            }, this.unlock = function(t) {
                var o = e.locked.get(t);
                if (void 0 !== o && 0 !== o.length) {
                    var n = o.pop();
                    e.locked.set(t, o), void 0 !== n && setTimeout(n, 0);
                } else e.locked.delete(t);
            };
        }
        return e.getInstance = function() {
            return void 0 === e.instance && (e.instance = new e), e.instance;
        }, e;
    }();
    t.default = function() {
        return o.getInstance();
    };
});
$c5aa5a6035c47210$var$o($c5aa5a6035c47210$var$i);
var $c5aa5a6035c47210$var$r = $c5aa5a6035c47210$var$o($c5aa5a6035c47210$var$n(function(e, o) {
    var n = $c5aa5a6035c47210$var$t && $c5aa5a6035c47210$var$t.__awaiter || function(e, t, o, n) {
        return new (o || (o = Promise))(function(i, r) {
            function s(e) {
                try {
                    c(n.next(e));
                } catch (e) {
                    r(e);
                }
            }
            function a(e) {
                try {
                    c(n.throw(e));
                } catch (e) {
                    r(e);
                }
            }
            function c(e) {
                e.done ? i(e.value) : new o(function(t) {
                    t(e.value);
                }).then(s, a);
            }
            c((n = n.apply(e, t || [])).next());
        });
    }, r = $c5aa5a6035c47210$var$t && $c5aa5a6035c47210$var$t.__generator || function(e, t) {
        var o, n, i, r, s = {
            label: 0,
            sent: function() {
                if (1 & i[0]) throw i[1];
                return i[1];
            },
            trys: [],
            ops: []
        };
        return r = {
            next: a(0),
            throw: a(1),
            return: a(2)
        }, "function" == typeof Symbol && (r[Symbol.iterator] = function() {
            return this;
        }), r;
        function a(r) {
            return function(a) {
                return function(r) {
                    if (o) throw new TypeError("Generator is already executing.");
                    for(; s;)try {
                        if (o = 1, n && (i = 2 & r[0] ? n.return : r[0] ? n.throw || ((i = n.return) && i.call(n), 0) : n.next) && !(i = i.call(n, r[1])).done) return i;
                        switch(n = 0, i && (r = [
                            2 & r[0],
                            i.value
                        ]), r[0]){
                            case 0:
                            case 1:
                                i = r;
                                break;
                            case 4:
                                return s.label++, {
                                    value: r[1],
                                    done: !1
                                };
                            case 5:
                                s.label++, n = r[1], r = [
                                    0
                                ];
                                continue;
                            case 7:
                                r = s.ops.pop(), s.trys.pop();
                                continue;
                            default:
                                if (!(i = s.trys, (i = i.length > 0 && i[i.length - 1]) || 6 !== r[0] && 2 !== r[0])) {
                                    s = 0;
                                    continue;
                                }
                                if (3 === r[0] && (!i || r[1] > i[0] && r[1] < i[3])) {
                                    s.label = r[1];
                                    break;
                                }
                                if (6 === r[0] && s.label < i[1]) {
                                    s.label = i[1], i = r;
                                    break;
                                }
                                if (i && s.label < i[2]) {
                                    s.label = i[2], s.ops.push(r);
                                    break;
                                }
                                i[2] && s.ops.pop(), s.trys.pop();
                                continue;
                        }
                        r = t.call(e, s);
                    } catch (e) {
                        r = [
                            6,
                            e
                        ], n = 0;
                    } finally{
                        o = i = 0;
                    }
                    if (5 & r[0]) throw r[1];
                    return {
                        value: r[0] ? r[1] : void 0,
                        done: !0
                    };
                }([
                    r,
                    a
                ]);
            };
        }
    }, s = $c5aa5a6035c47210$var$t;
    Object.defineProperty(o, "__esModule", {
        value: !0
    });
    var a = "browser-tabs-lock-key", c = {
        key: function(e) {
            return n(s, void 0, void 0, function() {
                return r(this, function(e) {
                    throw new Error("Unsupported");
                });
            });
        },
        getItem: function(e) {
            return n(s, void 0, void 0, function() {
                return r(this, function(e) {
                    throw new Error("Unsupported");
                });
            });
        },
        clear: function() {
            return n(s, void 0, void 0, function() {
                return r(this, function(e) {
                    return [
                        2,
                        window.localStorage.clear()
                    ];
                });
            });
        },
        removeItem: function(e) {
            return n(s, void 0, void 0, function() {
                return r(this, function(e) {
                    throw new Error("Unsupported");
                });
            });
        },
        setItem: function(e, t) {
            return n(s, void 0, void 0, function() {
                return r(this, function(e) {
                    throw new Error("Unsupported");
                });
            });
        },
        keySync: function(e) {
            return window.localStorage.key(e);
        },
        getItemSync: function(e) {
            return window.localStorage.getItem(e);
        },
        clearSync: function() {
            return window.localStorage.clear();
        },
        removeItemSync: function(e) {
            return window.localStorage.removeItem(e);
        },
        setItemSync: function(e, t) {
            return window.localStorage.setItem(e, t);
        }
    };
    function u(e) {
        return new Promise(function(t) {
            return setTimeout(t, e);
        });
    }
    function h(e) {
        for(var t = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXTZabcdefghiklmnopqrstuvwxyz", o = "", n = 0; n < e; n++)o += t[Math.floor(Math.random() * t.length)];
        return o;
    }
    var d = function() {
        function e(t) {
            this.acquiredIatSet = new Set, this.storageHandler = void 0, this.id = Date.now().toString() + h(15), this.acquireLock = this.acquireLock.bind(this), this.releaseLock = this.releaseLock.bind(this), this.releaseLock__private__ = this.releaseLock__private__.bind(this), this.waitForSomethingToChange = this.waitForSomethingToChange.bind(this), this.refreshLockWhileAcquired = this.refreshLockWhileAcquired.bind(this), this.storageHandler = t, void 0 === e.waiters && (e.waiters = []);
        }
        return e.prototype.acquireLock = function(t, o) {
            return void 0 === o && (o = 5e3), n(this, void 0, void 0, function() {
                var n, i, s, d, l, p, m;
                return r(this, function(r) {
                    switch(r.label){
                        case 0:
                            n = Date.now() + h(4), i = Date.now() + o, s = a + "-" + t, d = void 0 === this.storageHandler ? c : this.storageHandler, r.label = 1;
                        case 1:
                            return Date.now() < i ? [
                                4,
                                u(30)
                            ] : [
                                3,
                                8
                            ];
                        case 2:
                            return r.sent(), null !== d.getItemSync(s) ? [
                                3,
                                5
                            ] : (l = this.id + "-" + t + "-" + n, [
                                4,
                                u(Math.floor(25 * Math.random()))
                            ]);
                        case 3:
                            return r.sent(), d.setItemSync(s, JSON.stringify({
                                id: this.id,
                                iat: n,
                                timeoutKey: l,
                                timeAcquired: Date.now(),
                                timeRefreshed: Date.now()
                            })), [
                                4,
                                u(30)
                            ];
                        case 4:
                            return r.sent(), null !== (p = d.getItemSync(s)) && (m = JSON.parse(p)).id === this.id && m.iat === n ? (this.acquiredIatSet.add(n), this.refreshLockWhileAcquired(s, n), [
                                2,
                                !0
                            ]) : [
                                3,
                                7
                            ];
                        case 5:
                            return e.lockCorrector(void 0 === this.storageHandler ? c : this.storageHandler), [
                                4,
                                this.waitForSomethingToChange(i)
                            ];
                        case 6:
                            r.sent(), r.label = 7;
                        case 7:
                            return n = Date.now() + h(4), [
                                3,
                                1
                            ];
                        case 8:
                            return [
                                2,
                                !1
                            ];
                    }
                });
            });
        }, e.prototype.refreshLockWhileAcquired = function(e, t) {
            return n(this, void 0, void 0, function() {
                var o = this;
                return r(this, function(s) {
                    return setTimeout(function() {
                        return n(o, void 0, void 0, function() {
                            var o, n, s;
                            return r(this, function(r) {
                                switch(r.label){
                                    case 0:
                                        return [
                                            4,
                                            $c5aa5a6035c47210$var$i.default().lock(t)
                                        ];
                                    case 1:
                                        return r.sent(), this.acquiredIatSet.has(t) ? (o = void 0 === this.storageHandler ? c : this.storageHandler, null === (n = o.getItemSync(e)) ? ($c5aa5a6035c47210$var$i.default().unlock(t), [
                                            2
                                        ]) : ((s = JSON.parse(n)).timeRefreshed = Date.now(), o.setItemSync(e, JSON.stringify(s)), $c5aa5a6035c47210$var$i.default().unlock(t), this.refreshLockWhileAcquired(e, t), [
                                            2
                                        ])) : ($c5aa5a6035c47210$var$i.default().unlock(t), [
                                            2
                                        ]);
                                }
                            });
                        });
                    }, 1e3), [
                        2
                    ];
                });
            });
        }, e.prototype.waitForSomethingToChange = function(t) {
            return n(this, void 0, void 0, function() {
                return r(this, function(o) {
                    switch(o.label){
                        case 0:
                            return [
                                4,
                                new Promise(function(o) {
                                    var n = !1, i = Date.now(), r = !1;
                                    function s() {
                                        if (r || (window.removeEventListener("storage", s), e.removeFromWaiting(s), clearTimeout(a), r = !0), !n) {
                                            n = !0;
                                            var t = 50 - (Date.now() - i);
                                            t > 0 ? setTimeout(o, t) : o(null);
                                        }
                                    }
                                    window.addEventListener("storage", s), e.addToWaiting(s);
                                    var a = setTimeout(s, Math.max(0, t - Date.now()));
                                })
                            ];
                        case 1:
                            return o.sent(), [
                                2
                            ];
                    }
                });
            });
        }, e.addToWaiting = function(t) {
            this.removeFromWaiting(t), void 0 !== e.waiters && e.waiters.push(t);
        }, e.removeFromWaiting = function(t) {
            void 0 !== e.waiters && (e.waiters = e.waiters.filter(function(e) {
                return e !== t;
            }));
        }, e.notifyWaiters = function() {
            void 0 !== e.waiters && e.waiters.slice().forEach(function(e) {
                return e();
            });
        }, e.prototype.releaseLock = function(e) {
            return n(this, void 0, void 0, function() {
                return r(this, function(t) {
                    switch(t.label){
                        case 0:
                            return [
                                4,
                                this.releaseLock__private__(e)
                            ];
                        case 1:
                            return [
                                2,
                                t.sent()
                            ];
                    }
                });
            });
        }, e.prototype.releaseLock__private__ = function(t) {
            return n(this, void 0, void 0, function() {
                var o, n, s, u;
                return r(this, function(r) {
                    switch(r.label){
                        case 0:
                            return o = void 0 === this.storageHandler ? c : this.storageHandler, n = a + "-" + t, null === (s = o.getItemSync(n)) ? [
                                2
                            ] : (u = JSON.parse(s)).id !== this.id ? [
                                3,
                                2
                            ] : [
                                4,
                                $c5aa5a6035c47210$var$i.default().lock(u.iat)
                            ];
                        case 1:
                            r.sent(), this.acquiredIatSet.delete(u.iat), o.removeItemSync(n), $c5aa5a6035c47210$var$i.default().unlock(u.iat), e.notifyWaiters(), r.label = 2;
                        case 2:
                            return [
                                2
                            ];
                    }
                });
            });
        }, e.lockCorrector = function(t) {
            for(var o = Date.now() - 5e3, n = t, i = [], r = 0;;){
                var s = n.keySync(r);
                if (null === s) break;
                i.push(s), r++;
            }
            for(var c = !1, u = 0; u < i.length; u++){
                var h = i[u];
                if (h.includes(a)) {
                    var d = n.getItemSync(h);
                    if (null !== d) {
                        var l = JSON.parse(d);
                        (void 0 === l.timeRefreshed && l.timeAcquired < o || void 0 !== l.timeRefreshed && l.timeRefreshed < o) && (n.removeItemSync(h), c = !0);
                    }
                }
            }
            c && e.notifyWaiters();
        }, e.waiters = void 0, e;
    }();
    o.default = d;
}));
const $c5aa5a6035c47210$var$s = {
    timeoutInSeconds: 60
}, $c5aa5a6035c47210$var$a = {
    name: "auth0-spa-js",
    version: "2.5.0"
}, $c5aa5a6035c47210$var$c = ()=>Date.now();
class $c5aa5a6035c47210$export$7d465be8efa67280 extends Error {
    constructor(e, t){
        super(t), this.error = e, this.error_description = t, Object.setPrototypeOf(this, $c5aa5a6035c47210$export$7d465be8efa67280.prototype);
    }
    static fromPayload({ error: e, error_description: t }) {
        return new $c5aa5a6035c47210$export$7d465be8efa67280(e, t);
    }
}
class $c5aa5a6035c47210$export$cf0c46b07324e9c5 extends $c5aa5a6035c47210$export$7d465be8efa67280 {
    constructor(e, t, o, n = null){
        super(e, t), this.state = o, this.appState = n, Object.setPrototypeOf(this, $c5aa5a6035c47210$export$cf0c46b07324e9c5.prototype);
    }
}
class $c5aa5a6035c47210$export$66d311bf29d5c89c extends $c5aa5a6035c47210$export$7d465be8efa67280 {
    constructor(){
        super("timeout", "Timeout"), Object.setPrototypeOf(this, $c5aa5a6035c47210$export$66d311bf29d5c89c.prototype);
    }
}
class $c5aa5a6035c47210$export$ebbb83fe03f719a4 extends $c5aa5a6035c47210$export$66d311bf29d5c89c {
    constructor(e){
        super(), this.popup = e, Object.setPrototypeOf(this, $c5aa5a6035c47210$export$ebbb83fe03f719a4.prototype);
    }
}
class $c5aa5a6035c47210$export$f1f681f0fb26bb55 extends $c5aa5a6035c47210$export$7d465be8efa67280 {
    constructor(e){
        super("cancelled", "Popup closed"), this.popup = e, Object.setPrototypeOf(this, $c5aa5a6035c47210$export$f1f681f0fb26bb55.prototype);
    }
}
class $c5aa5a6035c47210$export$c59494f4dae44ada extends $c5aa5a6035c47210$export$7d465be8efa67280 {
    constructor(e, t, o){
        super(e, t), this.mfa_token = o, Object.setPrototypeOf(this, $c5aa5a6035c47210$export$c59494f4dae44ada.prototype);
    }
}
class $c5aa5a6035c47210$export$ac1d2a00f8e0a046 extends $c5aa5a6035c47210$export$7d465be8efa67280 {
    constructor(e, t){
        super("missing_refresh_token", `Missing Refresh Token (audience: '${$c5aa5a6035c47210$var$y(e, [
            "default"
        ])}', scope: '${$c5aa5a6035c47210$var$y(t)}')`), this.audience = e, this.scope = t, Object.setPrototypeOf(this, $c5aa5a6035c47210$export$ac1d2a00f8e0a046.prototype);
    }
}
class $c5aa5a6035c47210$export$ffb710231177fce3 extends $c5aa5a6035c47210$export$7d465be8efa67280 {
    constructor(e){
        super("use_dpop_nonce", "Server rejected DPoP proof: wrong nonce"), this.newDpopNonce = e, Object.setPrototypeOf(this, $c5aa5a6035c47210$export$ffb710231177fce3.prototype);
    }
}
function $c5aa5a6035c47210$var$y(e, t = []) {
    return e && !t.includes(e) ? e : "";
}
const $c5aa5a6035c47210$var$w = ()=>window.crypto, $c5aa5a6035c47210$var$b = ()=>{
    const e = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz-_~.";
    let t = "";
    return Array.from($c5aa5a6035c47210$var$w().getRandomValues(new Uint8Array(43))).forEach((o)=>t += e[o % e.length]), t;
}, $c5aa5a6035c47210$var$k = (e)=>btoa(e), $c5aa5a6035c47210$var$v = (t)=>{
    var { clientId: o } = t, n = $c5aa5a6035c47210$var$e(t, [
        "clientId"
    ]);
    return new URLSearchParams(((e)=>Object.keys(e).filter((t)=>void 0 !== e[t]).reduce((t, o)=>Object.assign(Object.assign({}, t), {
                [o]: e[o]
            }), {}))(Object.assign({
        client_id: o
    }, n))).toString();
}, $c5aa5a6035c47210$var$_ = (e)=>((e)=>decodeURIComponent(atob(e).split("").map((e)=>"%" + ("00" + e.charCodeAt(0).toString(16)).slice(-2)).join("")))(e.replace(/_/g, "/").replace(/-/g, "+")), $c5aa5a6035c47210$var$I = new TextEncoder, $c5aa5a6035c47210$var$S = new TextDecoder;
function $c5aa5a6035c47210$var$T(e) {
    return "string" == typeof e ? $c5aa5a6035c47210$var$I.encode(e) : $c5aa5a6035c47210$var$S.decode(e);
}
function $c5aa5a6035c47210$var$P(e) {
    if ("number" != typeof e.modulusLength || e.modulusLength < 2048) throw new $c5aa5a6035c47210$var$C(`${e.name} modulusLength must be at least 2048 bits`);
}
async function $c5aa5a6035c47210$var$O(e, t, o) {
    if (!1 === o.usages.includes("sign")) throw new TypeError('private CryptoKey instances used for signing assertions must include "sign" in their "usages"');
    const n = `${$c5aa5a6035c47210$var$x($c5aa5a6035c47210$var$T(JSON.stringify(e)))}.${$c5aa5a6035c47210$var$x($c5aa5a6035c47210$var$T(JSON.stringify(t)))}`;
    return `${n}.${$c5aa5a6035c47210$var$x(await crypto.subtle.sign(function(e) {
        switch(e.algorithm.name){
            case "ECDSA":
                return {
                    name: e.algorithm.name,
                    hash: "SHA-256"
                };
            case "RSA-PSS":
                return $c5aa5a6035c47210$var$P(e.algorithm), {
                    name: e.algorithm.name,
                    saltLength: 32
                };
            case "RSASSA-PKCS1-v1_5":
                return $c5aa5a6035c47210$var$P(e.algorithm), {
                    name: e.algorithm.name
                };
            case "Ed25519":
                return {
                    name: e.algorithm.name
                };
        }
        throw new $c5aa5a6035c47210$var$K;
    }(o), o, $c5aa5a6035c47210$var$T(n)))}`;
}
let $c5aa5a6035c47210$var$j;
if (Uint8Array.prototype.toBase64) $c5aa5a6035c47210$var$j = (e)=>(e instanceof ArrayBuffer && (e = new Uint8Array(e)), e.toBase64({
        alphabet: "base64url",
        omitPadding: !0
    }));
else {
    const e = 32768;
    $c5aa5a6035c47210$var$j = (t)=>{
        t instanceof ArrayBuffer && (t = new Uint8Array(t));
        const o = [];
        for(let n = 0; n < t.byteLength; n += e)o.push(String.fromCharCode.apply(null, t.subarray(n, n + e)));
        return btoa(o.join("")).replace(/=/g, "").replace(/\+/g, "-").replace(/\//g, "_");
    };
}
function $c5aa5a6035c47210$var$x(e) {
    return $c5aa5a6035c47210$var$j(e);
}
class $c5aa5a6035c47210$var$K extends Error {
    constructor(e){
        var t;
        super(null != e ? e : "operation not supported"), this.name = this.constructor.name, null === (t = Error.captureStackTrace) || void 0 === t || t.call(Error, this, this.constructor);
    }
}
class $c5aa5a6035c47210$var$C extends Error {
    constructor(e){
        var t;
        super(e), this.name = this.constructor.name, null === (t = Error.captureStackTrace) || void 0 === t || t.call(Error, this, this.constructor);
    }
}
function $c5aa5a6035c47210$var$E(e) {
    switch(e.algorithm.name){
        case "RSA-PSS":
            return function(e) {
                if ("SHA-256" === e.algorithm.hash.name) return "PS256";
                throw new $c5aa5a6035c47210$var$K("unsupported RsaHashedKeyAlgorithm hash name");
            }(e);
        case "RSASSA-PKCS1-v1_5":
            return function(e) {
                if ("SHA-256" === e.algorithm.hash.name) return "RS256";
                throw new $c5aa5a6035c47210$var$K("unsupported RsaHashedKeyAlgorithm hash name");
            }(e);
        case "ECDSA":
            return function(e) {
                if ("P-256" === e.algorithm.namedCurve) return "ES256";
                throw new $c5aa5a6035c47210$var$K("unsupported EcKeyAlgorithm namedCurve");
            }(e);
        case "Ed25519":
            return "Ed25519";
        default:
            throw new $c5aa5a6035c47210$var$K("unsupported CryptoKey algorithm name");
    }
}
function $c5aa5a6035c47210$var$z(e) {
    return e instanceof CryptoKey;
}
function $c5aa5a6035c47210$var$N(e) {
    return $c5aa5a6035c47210$var$z(e) && "public" === e.type;
}
async function $c5aa5a6035c47210$var$D(e, t, o, n, i, r) {
    const s = null == e ? void 0 : e.privateKey, a = null == e ? void 0 : e.publicKey;
    if (!$c5aa5a6035c47210$var$z(c = s) || "private" !== c.type) throw new TypeError('"keypair.privateKey" must be a private CryptoKey');
    var c;
    if (!$c5aa5a6035c47210$var$N(a)) throw new TypeError('"keypair.publicKey" must be a public CryptoKey');
    if (!0 !== a.extractable) throw new TypeError('"keypair.publicKey.extractable" must be true');
    if ("string" != typeof t) throw new TypeError('"htu" must be a string');
    if ("string" != typeof o) throw new TypeError('"htm" must be a string');
    if (void 0 !== n && "string" != typeof n) throw new TypeError('"nonce" must be a string or undefined');
    if (void 0 !== i && "string" != typeof i) throw new TypeError('"accessToken" must be a string or undefined');
    if (void 0 !== r && ("object" != typeof r || null === r || Array.isArray(r))) throw new TypeError('"additional" must be an object');
    return $c5aa5a6035c47210$var$O({
        alg: $c5aa5a6035c47210$var$E(s),
        typ: "dpop+jwt",
        jwk: await $c5aa5a6035c47210$var$Z(a)
    }, Object.assign(Object.assign({}, r), {
        iat: Math.floor(Date.now() / 1e3),
        jti: crypto.randomUUID(),
        htm: o,
        nonce: n,
        htu: t,
        ath: i ? $c5aa5a6035c47210$var$x(await crypto.subtle.digest("SHA-256", $c5aa5a6035c47210$var$T(i))) : void 0
    }), s);
}
async function $c5aa5a6035c47210$var$Z(e) {
    const { kty: t, e: o, n: n, x: i, y: r, crv: s } = await crypto.subtle.exportKey("jwk", e);
    return {
        kty: t,
        crv: s,
        e: o,
        n: n,
        x: i,
        y: r
    };
}
const $c5aa5a6035c47210$var$R = [
    "authorization_code",
    "refresh_token",
    "urn:ietf:params:oauth:grant-type:token-exchange"
];
function $c5aa5a6035c47210$var$U() {
    return async function(e, t) {
        var o;
        let n;
        if ("string" != typeof e || 0 === e.length) throw new TypeError('"alg" must be a non-empty string');
        switch(e){
            case "PS256":
                n = {
                    name: "RSA-PSS",
                    hash: "SHA-256",
                    modulusLength: 2048,
                    publicExponent: new Uint8Array([
                        1,
                        0,
                        1
                    ])
                };
                break;
            case "RS256":
                n = {
                    name: "RSASSA-PKCS1-v1_5",
                    hash: "SHA-256",
                    modulusLength: 2048,
                    publicExponent: new Uint8Array([
                        1,
                        0,
                        1
                    ])
                };
                break;
            case "ES256":
                n = {
                    name: "ECDSA",
                    namedCurve: "P-256"
                };
                break;
            case "Ed25519":
                n = {
                    name: "Ed25519"
                };
                break;
            default:
                throw new $c5aa5a6035c47210$var$K;
        }
        return crypto.subtle.generateKey(n, null !== (o = null == t ? void 0 : t.extractable) && void 0 !== o && o, [
            "sign",
            "verify"
        ]);
    }("ES256", {
        extractable: !1
    });
}
function $c5aa5a6035c47210$var$L(e) {
    return async function(e) {
        if (!$c5aa5a6035c47210$var$N(e)) throw new TypeError('"publicKey" must be a public CryptoKey');
        if (!0 !== e.extractable) throw new TypeError('"publicKey.extractable" must be true');
        const t = await $c5aa5a6035c47210$var$Z(e);
        let o;
        switch(t.kty){
            case "EC":
                o = {
                    crv: t.crv,
                    kty: t.kty,
                    x: t.x,
                    y: t.y
                };
                break;
            case "OKP":
                o = {
                    crv: t.crv,
                    kty: t.kty,
                    x: t.x
                };
                break;
            case "RSA":
                o = {
                    e: t.e,
                    kty: t.kty,
                    n: t.n
                };
                break;
            default:
                throw new $c5aa5a6035c47210$var$K("unsupported JWK kty");
        }
        return $c5aa5a6035c47210$var$x(await crypto.subtle.digest({
            name: "SHA-256"
        }, $c5aa5a6035c47210$var$T(JSON.stringify(o))));
    }(e.publicKey);
}
function $c5aa5a6035c47210$var$W({ keyPair: e, url: t, method: o, nonce: n, accessToken: i }) {
    const r = function(e) {
        const t = new URL(e);
        return t.search = "", t.hash = "", t.href;
    }(t);
    return $c5aa5a6035c47210$var$D(e, r, o, n, i);
}
const $c5aa5a6035c47210$var$H = async (e, t)=>{
    const o = await fetch(e, t);
    var n;
    return {
        ok: o.ok,
        json: await o.json(),
        headers: (n = o.headers, [
            ...n
        ].reduce((e, [t, o])=>(e[t] = o, e), {}))
    };
}, $c5aa5a6035c47210$var$A = async (e, t, o)=>{
    const n = new AbortController;
    let i;
    return t.signal = n.signal, Promise.race([
        $c5aa5a6035c47210$var$H(e, t),
        new Promise((e, t)=>{
            i = setTimeout(()=>{
                n.abort(), t(new Error("Timeout when executing 'fetch'"));
            }, o);
        })
    ]).finally(()=>{
        clearTimeout(i);
    });
}, $c5aa5a6035c47210$var$J = async (e, t, o, n, i, r, s, a)=>{
    var c, u;
    return c = {
        auth: {
            audience: t,
            scope: o
        },
        timeout: i,
        fetchUrl: e,
        fetchOptions: n,
        useFormData: s,
        useMrrt: a
    }, u = r, new Promise(function(e, t) {
        const o = new MessageChannel;
        o.port1.onmessage = function(n) {
            n.data.error ? t(new Error(n.data.error)) : e(n.data), o.port1.close();
        }, u.postMessage(c, [
            o.port2
        ]);
    });
}, $c5aa5a6035c47210$var$X = async (e, t, o, n, i, r, s = 1e4, a)=>i ? $c5aa5a6035c47210$var$J(e, t, o, n, s, i, r, a) : $c5aa5a6035c47210$var$A(e, n, s);
async function $c5aa5a6035c47210$var$V(t, o, n, i, r, s, a, c, h, d) {
    if (h) {
        const e = await h.generateProof({
            url: t,
            method: r.method || "GET",
            nonce: await h.getNonce()
        });
        r.headers = Object.assign(Object.assign({}, r.headers), {
            dpop: e
        });
    }
    let l, p = null;
    for(let e = 0; e < 3; e++)try {
        l = await $c5aa5a6035c47210$var$X(t, n, i, r, s, a, o, c), p = null;
        break;
    } catch (e) {
        p = e;
    }
    if (p) throw p;
    const y = l.json, { error: w, error_description: b } = y, k = $c5aa5a6035c47210$var$e(y, [
        "error",
        "error_description"
    ]), { headers: v, ok: _ } = l;
    let I;
    if (h && (I = v["dpop-nonce"], I && await h.setNonce(I)), !_) {
        const e = b || `HTTP error. Unable to fetch ${t}`;
        if ("mfa_required" === w) throw new $c5aa5a6035c47210$export$c59494f4dae44ada(w, e, k.mfa_token);
        if ("missing_refresh_token" === w) throw new $c5aa5a6035c47210$export$ac1d2a00f8e0a046(n, i);
        if ("use_dpop_nonce" === w) {
            if (!h || !I || d) throw new $c5aa5a6035c47210$export$ffb710231177fce3(I);
            return $c5aa5a6035c47210$var$V(t, o, n, i, r, s, a, c, h, !0);
        }
        throw new $c5aa5a6035c47210$export$7d465be8efa67280(w || "request_error", e);
    }
    return k;
}
async function $c5aa5a6035c47210$var$G(t, o) {
    var { baseUrl: n, timeout: i, audience: r, scope: s, auth0Client: c, useFormData: u, useMrrt: h, dpop: d } = t, l = $c5aa5a6035c47210$var$e(t, [
        "baseUrl",
        "timeout",
        "audience",
        "scope",
        "auth0Client",
        "useFormData",
        "useMrrt",
        "dpop"
    ]);
    const p = "urn:ietf:params:oauth:grant-type:token-exchange" === l.grant_type, m = "refresh_token" === l.grant_type && h, f = Object.assign(Object.assign(Object.assign(Object.assign({}, l), p && r && {
        audience: r
    }), p && s && {
        scope: s
    }), m && {
        audience: r,
        scope: s
    }), g = u ? $c5aa5a6035c47210$var$v(f) : JSON.stringify(f), y = (w = l.grant_type, $c5aa5a6035c47210$var$R.includes(w));
    var w;
    return await $c5aa5a6035c47210$var$V(`${n}/oauth/token`, i, r || "default", s, {
        method: "POST",
        body: g,
        headers: {
            "Content-Type": u ? "application/x-www-form-urlencoded" : "application/json",
            "Auth0-Client": btoa(JSON.stringify(c || $c5aa5a6035c47210$var$a))
        }
    }, o, u, h, y ? d : void 0);
}
const $c5aa5a6035c47210$var$F = (...e)=>{
    var t;
    return (t = e.filter(Boolean).join(" ").trim().split(/\s+/), Array.from(new Set(t))).join(" ");
};
class $c5aa5a6035c47210$export$2cb47d384c8dd787 {
    constructor(e, t = "@@auth0spajs@@", o){
        this.prefix = t, this.suffix = o, this.clientId = e.clientId, this.scope = e.scope, this.audience = e.audience;
    }
    toKey() {
        return [
            this.prefix,
            this.clientId,
            this.audience,
            this.scope,
            this.suffix
        ].filter(Boolean).join("::");
    }
    static fromKey(e) {
        const [t, o, n, i] = e.split("::");
        return new $c5aa5a6035c47210$export$2cb47d384c8dd787({
            clientId: o,
            scope: i,
            audience: n
        }, t);
    }
    static fromCacheEntry(e) {
        const { scope: t, audience: o, client_id: n } = e;
        return new $c5aa5a6035c47210$export$2cb47d384c8dd787({
            scope: t,
            audience: o,
            clientId: n
        });
    }
}
class $c5aa5a6035c47210$export$40ef2cb682e70737 {
    set(e, t) {
        localStorage.setItem(e, JSON.stringify(t));
    }
    get(e) {
        const t = window.localStorage.getItem(e);
        if (t) try {
            return JSON.parse(t);
        } catch (e) {
            return;
        }
    }
    remove(e) {
        localStorage.removeItem(e);
    }
    allKeys() {
        return Object.keys(window.localStorage).filter((e)=>e.startsWith("@@auth0spajs@@"));
    }
}
class $c5aa5a6035c47210$export$467265324939f47f {
    constructor(){
        this.enclosedCache = function() {
            let e = {};
            return {
                set (t, o) {
                    e[t] = o;
                },
                get (t) {
                    const o = e[t];
                    if (o) return o;
                },
                remove (t) {
                    delete e[t];
                },
                allKeys: ()=>Object.keys(e)
            };
        }();
    }
}
class $c5aa5a6035c47210$var$B {
    constructor(e, t, o){
        this.cache = e, this.keyManifest = t, this.nowProvider = o || $c5aa5a6035c47210$var$c;
    }
    async setIdToken(e, t, o) {
        var n;
        const i = this.getIdTokenCacheKey(e);
        await this.cache.set(i, {
            id_token: t,
            decodedToken: o
        }), await (null === (n = this.keyManifest) || void 0 === n ? void 0 : n.add(i));
    }
    async getIdToken(e) {
        const t = await this.cache.get(this.getIdTokenCacheKey(e.clientId));
        if (!t && e.scope && e.audience) {
            const t = await this.get(e);
            if (!t) return;
            if (!t.id_token || !t.decodedToken) return;
            return {
                id_token: t.id_token,
                decodedToken: t.decodedToken
            };
        }
        if (t) return {
            id_token: t.id_token,
            decodedToken: t.decodedToken
        };
    }
    async get(e, t = 0, o = !1, n) {
        var i;
        let r = await this.cache.get(e.toKey());
        if (!r) {
            const t = await this.getCacheKeys();
            if (!t) return;
            const i = this.matchExistingCacheKey(e, t);
            if (i && (r = await this.cache.get(i)), !i && o && "cache-only" !== n) return this.getEntryWithRefreshToken(e, t);
        }
        if (!r) return;
        const s = await this.nowProvider(), a = Math.floor(s / 1e3);
        return r.expiresAt - t < a ? r.body.refresh_token ? this.modifiedCachedEntry(r, e) : (await this.cache.remove(e.toKey()), void await (null === (i = this.keyManifest) || void 0 === i ? void 0 : i.remove(e.toKey()))) : r.body;
    }
    async modifiedCachedEntry(e, t) {
        return e.body = {
            refresh_token: e.body.refresh_token,
            audience: e.body.audience,
            scope: e.body.scope
        }, await this.cache.set(t.toKey(), e), {
            refresh_token: e.body.refresh_token,
            audience: e.body.audience,
            scope: e.body.scope
        };
    }
    async set(e) {
        var t;
        const o = new $c5aa5a6035c47210$export$2cb47d384c8dd787({
            clientId: e.client_id,
            scope: e.scope,
            audience: e.audience
        }), n = await this.wrapCacheEntry(e);
        await this.cache.set(o.toKey(), n), await (null === (t = this.keyManifest) || void 0 === t ? void 0 : t.add(o.toKey()));
    }
    async clear(e) {
        var t;
        const o = await this.getCacheKeys();
        o && (await o.filter((t)=>!e || t.includes(e)).reduce(async (e, t)=>{
            await e, await this.cache.remove(t);
        }, Promise.resolve()), await (null === (t = this.keyManifest) || void 0 === t ? void 0 : t.clear()));
    }
    async wrapCacheEntry(e) {
        const t = await this.nowProvider();
        return {
            body: e,
            expiresAt: Math.floor(t / 1e3) + e.expires_in
        };
    }
    async getCacheKeys() {
        var e;
        return this.keyManifest ? null === (e = await this.keyManifest.get()) || void 0 === e ? void 0 : e.keys : this.cache.allKeys ? this.cache.allKeys() : void 0;
    }
    getIdTokenCacheKey(e) {
        return new $c5aa5a6035c47210$export$2cb47d384c8dd787({
            clientId: e
        }, "@@auth0spajs@@", "@@user@@").toKey();
    }
    matchExistingCacheKey(e, t) {
        return t.filter((t)=>{
            var o;
            const n = $c5aa5a6035c47210$export$2cb47d384c8dd787.fromKey(t), i = new Set(n.scope && n.scope.split(" ")), r = (null === (o = e.scope) || void 0 === o ? void 0 : o.split(" ")) || [], s = n.scope && r.reduce((e, t)=>e && i.has(t), !0);
            return "@@auth0spajs@@" === n.prefix && n.clientId === e.clientId && n.audience === e.audience && s;
        })[0];
    }
    async getEntryWithRefreshToken(e, t) {
        var o;
        for (const n of t){
            const t = $c5aa5a6035c47210$export$2cb47d384c8dd787.fromKey(n);
            if ("@@auth0spajs@@" === t.prefix && t.clientId === e.clientId) {
                const t = await this.cache.get(n);
                if (null === (o = null == t ? void 0 : t.body) || void 0 === o ? void 0 : o.refresh_token) return this.modifiedCachedEntry(t, e);
            }
        }
    }
    async updateEntry(e, t) {
        var o;
        const n = await this.getCacheKeys();
        if (n) for (const i of n){
            const n = await this.cache.get(i);
            if ((null === (o = null == n ? void 0 : n.body) || void 0 === o ? void 0 : o.refresh_token) === e) {
                const e = Object.assign(Object.assign({}, n.body), {
                    refresh_token: t
                });
                await this.set(e);
            }
        }
    }
}
class $c5aa5a6035c47210$var$q {
    constructor(e, t, o){
        this.storage = e, this.clientId = t, this.cookieDomain = o, this.storageKey = `a0.spajs.txs.${this.clientId}`;
    }
    create(e) {
        this.storage.save(this.storageKey, e, {
            daysUntilExpire: 1,
            cookieDomain: this.cookieDomain
        });
    }
    get() {
        return this.storage.get(this.storageKey);
    }
    remove() {
        this.storage.remove(this.storageKey, {
            cookieDomain: this.cookieDomain
        });
    }
}
const $c5aa5a6035c47210$var$Q = (e)=>"number" == typeof e, $c5aa5a6035c47210$var$ee = [
    "iss",
    "aud",
    "exp",
    "nbf",
    "iat",
    "jti",
    "azp",
    "nonce",
    "auth_time",
    "at_hash",
    "c_hash",
    "acr",
    "amr",
    "sub_jwk",
    "cnf",
    "sip_from_tag",
    "sip_date",
    "sip_callid",
    "sip_cseq_num",
    "sip_via_branch",
    "orig",
    "dest",
    "mky",
    "events",
    "toe",
    "txn",
    "rph",
    "sid",
    "vot",
    "vtm"
], $c5aa5a6035c47210$var$te = (e)=>{
    if (!e.id_token) throw new Error("ID token is required but missing");
    const t = ((e)=>{
        const t = e.split("."), [o, n, i] = t;
        if (3 !== t.length || !o || !n || !i) throw new Error("ID token could not be decoded");
        const r = JSON.parse($c5aa5a6035c47210$var$_(n)), s = {
            __raw: e
        }, a = {};
        return Object.keys(r).forEach((e)=>{
            s[e] = r[e], $c5aa5a6035c47210$var$ee.includes(e) || (a[e] = r[e]);
        }), {
            encoded: {
                header: o,
                payload: n,
                signature: i
            },
            header: JSON.parse($c5aa5a6035c47210$var$_(o)),
            claims: s,
            user: a
        };
    })(e.id_token);
    if (!t.claims.iss) throw new Error("Issuer (iss) claim must be a string present in the ID token");
    if (t.claims.iss !== e.iss) throw new Error(`Issuer (iss) claim mismatch in the ID token; expected "${e.iss}", found "${t.claims.iss}"`);
    if (!t.user.sub) throw new Error("Subject (sub) claim must be a string present in the ID token");
    if ("RS256" !== t.header.alg) throw new Error(`Signature algorithm of "${t.header.alg}" is not supported. Expected the ID token to be signed with "RS256".`);
    if (!t.claims.aud || "string" != typeof t.claims.aud && !Array.isArray(t.claims.aud)) throw new Error("Audience (aud) claim must be a string or array of strings present in the ID token");
    if (Array.isArray(t.claims.aud)) {
        if (!t.claims.aud.includes(e.aud)) throw new Error(`Audience (aud) claim mismatch in the ID token; expected "${e.aud}" but was not one of "${t.claims.aud.join(", ")}"`);
        if (t.claims.aud.length > 1) {
            if (!t.claims.azp) throw new Error("Authorized Party (azp) claim must be a string present in the ID token when Audience (aud) claim has multiple values");
            if (t.claims.azp !== e.aud) throw new Error(`Authorized Party (azp) claim mismatch in the ID token; expected "${e.aud}", found "${t.claims.azp}"`);
        }
    } else if (t.claims.aud !== e.aud) throw new Error(`Audience (aud) claim mismatch in the ID token; expected "${e.aud}" but found "${t.claims.aud}"`);
    if (e.nonce) {
        if (!t.claims.nonce) throw new Error("Nonce (nonce) claim must be a string present in the ID token");
        if (t.claims.nonce !== e.nonce) throw new Error(`Nonce (nonce) claim mismatch in the ID token; expected "${e.nonce}", found "${t.claims.nonce}"`);
    }
    if (e.max_age && !$c5aa5a6035c47210$var$Q(t.claims.auth_time)) throw new Error("Authentication Time (auth_time) claim must be a number present in the ID token when Max Age (max_age) is specified");
    if (null == t.claims.exp || !$c5aa5a6035c47210$var$Q(t.claims.exp)) throw new Error("Expiration Time (exp) claim must be a number present in the ID token");
    if (!$c5aa5a6035c47210$var$Q(t.claims.iat)) throw new Error("Issued At (iat) claim must be a number present in the ID token");
    const o = e.leeway || 60, n = new Date(e.now || Date.now()), i = new Date(0);
    if (i.setUTCSeconds(t.claims.exp + o), n > i) throw new Error(`Expiration Time (exp) claim error in the ID token; current time (${n}) is after expiration time (${i})`);
    if (null != t.claims.nbf && $c5aa5a6035c47210$var$Q(t.claims.nbf)) {
        const e = new Date(0);
        if (e.setUTCSeconds(t.claims.nbf - o), n < e) throw new Error(`Not Before time (nbf) claim in the ID token indicates that this token can't be used just yet. Current time (${n}) is before ${e}`);
    }
    if (null != t.claims.auth_time && $c5aa5a6035c47210$var$Q(t.claims.auth_time)) {
        const i = new Date(0);
        if (i.setUTCSeconds(parseInt(t.claims.auth_time) + e.max_age + o), n > i) throw new Error(`Authentication Time (auth_time) claim in the ID token indicates that too much time has passed since the last end-user authentication. Current time (${n}) is after last auth at ${i}`);
    }
    if (e.organization) {
        const o = e.organization.trim();
        if (o.startsWith("org_")) {
            const e = o;
            if (!t.claims.org_id) throw new Error("Organization ID (org_id) claim must be a string present in the ID token");
            if (e !== t.claims.org_id) throw new Error(`Organization ID (org_id) claim mismatch in the ID token; expected "${e}", found "${t.claims.org_id}"`);
        } else {
            const e = o.toLowerCase();
            if (!t.claims.org_name) throw new Error("Organization Name (org_name) claim must be a string present in the ID token");
            if (e !== t.claims.org_name) throw new Error(`Organization Name (org_name) claim mismatch in the ID token; expected "${e}", found "${t.claims.org_name}"`);
        }
    }
    return t;
};
var $c5aa5a6035c47210$var$oe = $c5aa5a6035c47210$var$n(function(e, o) {
    var n = $c5aa5a6035c47210$var$t && $c5aa5a6035c47210$var$t.__assign || function() {
        return n = Object.assign || function(e) {
            for(var t, o = 1, n = arguments.length; o < n; o++)for(var i in t = arguments[o])Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
            return e;
        }, n.apply(this, arguments);
    };
    function i(e, t) {
        if (!t) return "";
        var o = "; " + e;
        return !0 === t ? o : o + "=" + t;
    }
    function r(e, t, o) {
        return encodeURIComponent(e).replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent).replace(/\(/g, "%28").replace(/\)/g, "%29") + "=" + encodeURIComponent(t).replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent) + function(e) {
            if ("number" == typeof e.expires) {
                var t = new Date;
                t.setMilliseconds(t.getMilliseconds() + 864e5 * e.expires), e.expires = t;
            }
            return i("Expires", e.expires ? e.expires.toUTCString() : "") + i("Domain", e.domain) + i("Path", e.path) + i("Secure", e.secure) + i("SameSite", e.sameSite);
        }(o);
    }
    function s(e) {
        for(var t = {}, o = e ? e.split("; ") : [], n = /(%[\dA-F]{2})+/gi, i = 0; i < o.length; i++){
            var r = o[i].split("="), s = r.slice(1).join("=");
            '"' === s.charAt(0) && (s = s.slice(1, -1));
            try {
                t[r[0].replace(n, decodeURIComponent)] = s.replace(n, decodeURIComponent);
            } catch (e) {}
        }
        return t;
    }
    function a() {
        return s(document.cookie);
    }
    function c(e, t, o) {
        document.cookie = r(e, t, n({
            path: "/"
        }, o));
    }
    o.__esModule = !0, o.encode = r, o.parse = s, o.getAll = a, o.get = function(e) {
        return a()[e];
    }, o.set = c, o.remove = function(e, t) {
        c(e, "", n(n({}, t), {
            expires: -1
        }));
    };
});
$c5aa5a6035c47210$var$o($c5aa5a6035c47210$var$oe), $c5aa5a6035c47210$var$oe.encode, $c5aa5a6035c47210$var$oe.parse, $c5aa5a6035c47210$var$oe.getAll;
var $c5aa5a6035c47210$var$ne = $c5aa5a6035c47210$var$oe.get, $c5aa5a6035c47210$var$ie = $c5aa5a6035c47210$var$oe.set, $c5aa5a6035c47210$var$re = $c5aa5a6035c47210$var$oe.remove;
const $c5aa5a6035c47210$var$se = {
    get (e) {
        const t = $c5aa5a6035c47210$var$ne(e);
        if (void 0 !== t) return JSON.parse(t);
    },
    save (e, t, o) {
        let n = {};
        "https:" === window.location.protocol && (n = {
            secure: !0,
            sameSite: "none"
        }), (null == o ? void 0 : o.daysUntilExpire) && (n.expires = o.daysUntilExpire), (null == o ? void 0 : o.cookieDomain) && (n.domain = o.cookieDomain), $c5aa5a6035c47210$var$ie(e, JSON.stringify(t), n);
    },
    remove (e, t) {
        let o = {};
        (null == t ? void 0 : t.cookieDomain) && (o.domain = t.cookieDomain), $c5aa5a6035c47210$var$re(e, o);
    }
}, $c5aa5a6035c47210$var$ae = {
    get (e) {
        const t = $c5aa5a6035c47210$var$se.get(e);
        return t || $c5aa5a6035c47210$var$se.get(`_legacy_${e}`);
    },
    save (e, t, o) {
        let n = {};
        "https:" === window.location.protocol && (n = {
            secure: !0
        }), (null == o ? void 0 : o.daysUntilExpire) && (n.expires = o.daysUntilExpire), (null == o ? void 0 : o.cookieDomain) && (n.domain = o.cookieDomain), $c5aa5a6035c47210$var$ie(`_legacy_${e}`, JSON.stringify(t), n), $c5aa5a6035c47210$var$se.save(e, t, o);
    },
    remove (e, t) {
        let o = {};
        (null == t ? void 0 : t.cookieDomain) && (o.domain = t.cookieDomain), $c5aa5a6035c47210$var$re(e, o), $c5aa5a6035c47210$var$se.remove(e, t), $c5aa5a6035c47210$var$se.remove(`_legacy_${e}`, t);
    }
}, $c5aa5a6035c47210$var$ce = {
    get (e) {
        if ("undefined" == typeof sessionStorage) return;
        const t = sessionStorage.getItem(e);
        return null != t ? JSON.parse(t) : void 0;
    },
    save (e, t) {
        sessionStorage.setItem(e, JSON.stringify(t));
    },
    remove (e) {
        sessionStorage.removeItem(e);
    }
};
function $c5aa5a6035c47210$var$ue(e, t, o) {
    var n = void 0 === t ? null : t, i = function(e, t) {
        var o = atob(e);
        if (t) {
            for(var n = new Uint8Array(o.length), i = 0, r = o.length; i < r; ++i)n[i] = o.charCodeAt(i);
            return String.fromCharCode.apply(null, new Uint16Array(n.buffer));
        }
        return o;
    }(e, void 0 !== o && o), r = i.indexOf("\n", 10) + 1, s = i.substring(r) + (n ? "//# sourceMappingURL=" + n : ""), a = new Blob([
        s
    ], {
        type: "application/javascript"
    });
    return URL.createObjectURL(a);
}
var $c5aa5a6035c47210$var$he, $c5aa5a6035c47210$var$de, $c5aa5a6035c47210$var$le, $c5aa5a6035c47210$var$pe, $c5aa5a6035c47210$var$me = ($c5aa5a6035c47210$var$he = "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", $c5aa5a6035c47210$var$de = null, $c5aa5a6035c47210$var$le = !1, function(e) {
    return $c5aa5a6035c47210$var$pe = $c5aa5a6035c47210$var$pe || $c5aa5a6035c47210$var$ue($c5aa5a6035c47210$var$he, $c5aa5a6035c47210$var$de, $c5aa5a6035c47210$var$le), new Worker($c5aa5a6035c47210$var$pe, e);
});
const $c5aa5a6035c47210$var$fe = {};
class $c5aa5a6035c47210$var$ge {
    constructor(e, t){
        this.cache = e, this.clientId = t, this.manifestKey = this.createManifestKeyFrom(this.clientId);
    }
    async add(e) {
        var t;
        const o = new Set((null === (t = await this.cache.get(this.manifestKey)) || void 0 === t ? void 0 : t.keys) || []);
        o.add(e), await this.cache.set(this.manifestKey, {
            keys: [
                ...o
            ]
        });
    }
    async remove(e) {
        const t = await this.cache.get(this.manifestKey);
        if (t) {
            const o = new Set(t.keys);
            return o.delete(e), o.size > 0 ? await this.cache.set(this.manifestKey, {
                keys: [
                    ...o
                ]
            }) : await this.cache.remove(this.manifestKey);
        }
    }
    get() {
        return this.cache.get(this.manifestKey);
    }
    clear() {
        return this.cache.remove(this.manifestKey);
    }
    createManifestKeyFrom(e) {
        return `@@auth0spajs@@::${e}`;
    }
}
const $c5aa5a6035c47210$var$ye = {
    memory: ()=>(new $c5aa5a6035c47210$export$467265324939f47f).enclosedCache,
    localstorage: ()=>new $c5aa5a6035c47210$export$40ef2cb682e70737
}, $c5aa5a6035c47210$var$we = (e)=>$c5aa5a6035c47210$var$ye[e], $c5aa5a6035c47210$var$be = (t)=>{
    const { openUrl: o, onRedirect: n } = t, i = $c5aa5a6035c47210$var$e(t, [
        "openUrl",
        "onRedirect"
    ]);
    return Object.assign(Object.assign({}, i), {
        openUrl: !1 === o || o ? o : n
    });
}, $c5aa5a6035c47210$var$ke = (e, t)=>{
    const o = (null == t ? void 0 : t.split(" ")) || [];
    return ((null == e ? void 0 : e.split(" ")) || []).every((e)=>o.includes(e));
}, $c5aa5a6035c47210$var$ve = {
    NONCE: "nonce",
    KEYPAIR: "keypair"
};
class $c5aa5a6035c47210$var$_e {
    constructor(e){
        this.clientId = e;
    }
    getVersion() {
        return 1;
    }
    createDbHandle() {
        const e = window.indexedDB.open("auth0-spa-js", this.getVersion());
        return new Promise((t, o)=>{
            e.onupgradeneeded = ()=>Object.values($c5aa5a6035c47210$var$ve).forEach((t)=>e.result.createObjectStore(t)), e.onerror = ()=>o(e.error), e.onsuccess = ()=>t(e.result);
        });
    }
    async getDbHandle() {
        return this.dbHandle || (this.dbHandle = await this.createDbHandle()), this.dbHandle;
    }
    async executeDbRequest(e, t, o) {
        const n = o((await this.getDbHandle()).transaction(e, t).objectStore(e));
        return new Promise((e, t)=>{
            n.onsuccess = ()=>e(n.result), n.onerror = ()=>t(n.error);
        });
    }
    buildKey(e) {
        const t = e ? `_${e}` : "auth0";
        return `${this.clientId}::${t}`;
    }
    setNonce(e, t) {
        return this.save($c5aa5a6035c47210$var$ve.NONCE, this.buildKey(t), e);
    }
    setKeyPair(e) {
        return this.save($c5aa5a6035c47210$var$ve.KEYPAIR, this.buildKey(), e);
    }
    async save(e, t, o) {
        await this.executeDbRequest(e, "readwrite", (e)=>e.put(o, t));
    }
    findNonce(e) {
        return this.find($c5aa5a6035c47210$var$ve.NONCE, this.buildKey(e));
    }
    findKeyPair() {
        return this.find($c5aa5a6035c47210$var$ve.KEYPAIR, this.buildKey());
    }
    find(e, t) {
        return this.executeDbRequest(e, "readonly", (e)=>e.get(t));
    }
    async deleteBy(e, t) {
        const o = await this.executeDbRequest(e, "readonly", (e)=>e.getAllKeys());
        null == o || o.filter(t).map((t)=>this.executeDbRequest(e, "readwrite", (e)=>e.delete(t)));
    }
    deleteByClientId(e, t) {
        return this.deleteBy(e, (e)=>"string" == typeof e && e.startsWith(`${t}::`));
    }
    clearNonces() {
        return this.deleteByClientId($c5aa5a6035c47210$var$ve.NONCE, this.clientId);
    }
    clearKeyPairs() {
        return this.deleteByClientId($c5aa5a6035c47210$var$ve.KEYPAIR, this.clientId);
    }
}
class $c5aa5a6035c47210$var$Ie {
    constructor(e){
        this.storage = new $c5aa5a6035c47210$var$_e(e);
    }
    getNonce(e) {
        return this.storage.findNonce(e);
    }
    setNonce(e, t) {
        return this.storage.setNonce(e, t);
    }
    async getOrGenerateKeyPair() {
        let e = await this.storage.findKeyPair();
        return e || (e = await $c5aa5a6035c47210$var$U(), await this.storage.setKeyPair(e)), e;
    }
    async generateProof(e) {
        const t = await this.getOrGenerateKeyPair();
        return $c5aa5a6035c47210$var$W(Object.assign({
            keyPair: t
        }, e));
    }
    async calculateThumbprint() {
        return $c5aa5a6035c47210$var$L(await this.getOrGenerateKeyPair());
    }
    async clear() {
        await Promise.all([
            this.storage.clearNonces(),
            this.storage.clearKeyPairs()
        ]);
    }
}
class $c5aa5a6035c47210$var$Se {
    constructor(e, t){
        this.hooks = t, this.config = Object.assign(Object.assign({}, e), {
            fetch: e.fetch || ("undefined" == typeof window ? fetch : window.fetch.bind(window))
        });
    }
    isAbsoluteUrl(e) {
        return /^(https?:)?\/\//i.test(e);
    }
    buildUrl(e, t) {
        if (t) {
            if (this.isAbsoluteUrl(t)) return t;
            if (e) return `${e.replace(/\/?\/$/, "")}/${t.replace(/^\/+/, "")}`;
        }
        throw new TypeError("`url` must be absolute or `baseUrl` non-empty.");
    }
    getAccessToken(e) {
        return this.config.getAccessToken ? this.config.getAccessToken(e) : this.hooks.getAccessToken(e);
    }
    buildBaseRequest(e, t) {
        const o = new Request(e, t);
        return this.config.baseUrl ? new Request(this.buildUrl(this.config.baseUrl, o.url), o) : o;
    }
    async setAuthorizationHeader(e, t) {
        e.headers.set("authorization", `${this.config.dpopNonceId ? "DPoP" : "Bearer"} ${t}`);
    }
    async setDpopProofHeader(e, t) {
        if (!this.config.dpopNonceId) return;
        const o = await this.hooks.getDpopNonce(), n = await this.hooks.generateDpopProof({
            accessToken: t,
            method: e.method,
            nonce: o,
            url: e.url
        });
        e.headers.set("dpop", n);
    }
    async prepareRequest(e, t) {
        const o = await this.getAccessToken(t);
        this.setAuthorizationHeader(e, o), await this.setDpopProofHeader(e, o);
    }
    getHeader(e, t) {
        return Array.isArray(e) ? new Headers(e).get(t) || "" : "function" == typeof e.get ? e.get(t) || "" : e[t] || "";
    }
    hasUseDpopNonceError(e) {
        if (401 !== e.status) return !1;
        return this.getHeader(e.headers, "www-authenticate").includes("use_dpop_nonce");
    }
    async handleResponse(e, t) {
        const o = this.getHeader(e.headers, "dpop-nonce");
        if (o && await this.hooks.setDpopNonce(o), !this.hasUseDpopNonceError(e)) return e;
        if (!o || !t.onUseDpopNonceError) throw new $c5aa5a6035c47210$export$ffb710231177fce3(o);
        return t.onUseDpopNonceError();
    }
    async internalFetchWithAuth(e, t, o, n) {
        const i = this.buildBaseRequest(e, t);
        await this.prepareRequest(i, n);
        const r = await this.config.fetch(i);
        return this.handleResponse(r, o);
    }
    fetchWithAuth(e, t, o) {
        const n = {
            onUseDpopNonceError: ()=>this.internalFetchWithAuth(e, t, Object.assign(Object.assign({}, n), {
                    onUseDpopNonceError: void 0
                }), o)
        };
        return this.internalFetchWithAuth(e, t, n, o);
    }
}
const $c5aa5a6035c47210$var$Te = new $c5aa5a6035c47210$var$r;
class $c5aa5a6035c47210$export$b50978e389d6e1d5 {
    constructor(e){
        let t, o;
        if (this.userCache = (new $c5aa5a6035c47210$export$467265324939f47f).enclosedCache, this.defaultOptions = {
            authorizationParams: {
                scope: "openid profile email"
            },
            useRefreshTokensFallback: !1,
            useFormData: !0
        }, this._releaseLockOnPageHide = async ()=>{
            await $c5aa5a6035c47210$var$Te.releaseLock("auth0.lock.getTokenSilently"), window.removeEventListener("pagehide", this._releaseLockOnPageHide);
        }, this.options = Object.assign(Object.assign(Object.assign({}, this.defaultOptions), e), {
            authorizationParams: Object.assign(Object.assign({}, this.defaultOptions.authorizationParams), e.authorizationParams)
        }), "undefined" != typeof window && (()=>{
            if (!$c5aa5a6035c47210$var$w()) throw new Error("For security reasons, `window.crypto` is required to run `auth0-spa-js`.");
            if (void 0 === $c5aa5a6035c47210$var$w().subtle) throw new Error("\n      auth0-spa-js must run on a secure origin. See https://github.com/auth0/auth0-spa-js/blob/main/FAQ.md#why-do-i-get-auth0-spa-js-must-run-on-a-secure-origin for more information.\n    ");
        })(), e.cache && e.cacheLocation && console.warn("Both `cache` and `cacheLocation` options have been specified in the Auth0Client configuration; ignoring `cacheLocation` and using `cache`."), e.cache) o = e.cache;
        else {
            if (t = e.cacheLocation || "memory", !$c5aa5a6035c47210$var$we(t)) throw new Error(`Invalid cache location "${t}"`);
            o = $c5aa5a6035c47210$var$we(t)();
        }
        this.httpTimeoutMs = e.httpTimeoutInSeconds ? 1e3 * e.httpTimeoutInSeconds : 1e4, this.cookieStorage = !1 === e.legacySameSiteCookie ? $c5aa5a6035c47210$var$se : $c5aa5a6035c47210$var$ae, this.orgHintCookieName = `auth0.${this.options.clientId}.organization_hint`, this.isAuthenticatedCookieName = ((e)=>`auth0.${e}.is.authenticated`)(this.options.clientId), this.sessionCheckExpiryDays = e.sessionCheckExpiryDays || 1;
        const n = e.useCookiesForTransactions ? this.cookieStorage : $c5aa5a6035c47210$var$ce;
        var i;
        this.scope = $c5aa5a6035c47210$var$F("openid", this.options.authorizationParams.scope, this.options.useRefreshTokens ? "offline_access" : ""), this.transactionManager = new $c5aa5a6035c47210$var$q(n, this.options.clientId, this.options.cookieDomain), this.nowProvider = this.options.nowProvider || $c5aa5a6035c47210$var$c, this.cacheManager = new $c5aa5a6035c47210$var$B(o, o.allKeys ? void 0 : new $c5aa5a6035c47210$var$ge(o, this.options.clientId), this.nowProvider), this.dpop = this.options.useDpop ? new $c5aa5a6035c47210$var$Ie(this.options.clientId) : void 0, this.domainUrl = (i = this.options.domain, /^https?:\/\//.test(i) ? i : `https://${i}`), this.tokenIssuer = ((e, t)=>e ? e.startsWith("https://") ? e : `https://${e}/` : `${t}/`)(this.options.issuer, this.domainUrl), "undefined" != typeof window && window.Worker && this.options.useRefreshTokens && "memory" === t && (this.options.workerUrl ? this.worker = new Worker(this.options.workerUrl) : this.worker = new $c5aa5a6035c47210$var$me);
    }
    _url(e) {
        const t = encodeURIComponent(btoa(JSON.stringify(this.options.auth0Client || $c5aa5a6035c47210$var$a)));
        return `${this.domainUrl}${e}&auth0Client=${t}`;
    }
    _authorizeUrl(e) {
        return this._url(`/authorize?${$c5aa5a6035c47210$var$v(e)}`);
    }
    async _verifyIdToken(e, t, o) {
        const n = await this.nowProvider();
        var i;
        return $c5aa5a6035c47210$var$te({
            iss: this.tokenIssuer,
            aud: this.options.clientId,
            id_token: e,
            nonce: t,
            organization: o,
            leeway: this.options.leeway,
            max_age: (i = this.options.authorizationParams.max_age, "string" != typeof i ? i : parseInt(i, 10) || void 0),
            now: n
        });
    }
    _processOrgHint(e) {
        e ? this.cookieStorage.save(this.orgHintCookieName, e, {
            daysUntilExpire: this.sessionCheckExpiryDays,
            cookieDomain: this.options.cookieDomain
        }) : this.cookieStorage.remove(this.orgHintCookieName, {
            cookieDomain: this.options.cookieDomain
        });
    }
    async _prepareAuthorizeUrl(e, t, o) {
        var n;
        const i = $c5aa5a6035c47210$var$k($c5aa5a6035c47210$var$b()), r = $c5aa5a6035c47210$var$k($c5aa5a6035c47210$var$b()), s = $c5aa5a6035c47210$var$b(), a = ((e)=>{
            const t = new Uint8Array(e);
            return ((e)=>{
                const t = {
                    "+": "-",
                    "/": "_",
                    "=": ""
                };
                return e.replace(/[+/=]/g, (e)=>t[e]);
            })(window.btoa(String.fromCharCode(...Array.from(t))));
        })(await (async (e)=>{
            const t = $c5aa5a6035c47210$var$w().subtle.digest({
                name: "SHA-256"
            }, (new TextEncoder).encode(e));
            return await t;
        })(s)), c = await (null === (n = this.dpop) || void 0 === n ? void 0 : n.calculateThumbprint()), u = ((e, t, o, n, i, r, s, a, c)=>Object.assign(Object.assign(Object.assign({
                client_id: e.clientId
            }, e.authorizationParams), o), {
                scope: $c5aa5a6035c47210$var$F(t, o.scope),
                response_type: "code",
                response_mode: a || "query",
                state: n,
                nonce: i,
                redirect_uri: s || e.authorizationParams.redirect_uri,
                code_challenge: r,
                code_challenge_method: "S256",
                dpop_jkt: c
            }))(this.options, this.scope, e, i, r, a, e.redirect_uri || this.options.authorizationParams.redirect_uri || o, null == t ? void 0 : t.response_mode, c), h = this._authorizeUrl(u);
        return {
            nonce: r,
            code_verifier: s,
            scope: u.scope,
            audience: u.audience || "default",
            redirect_uri: u.redirect_uri,
            state: i,
            url: h
        };
    }
    async loginWithPopup(e, t) {
        var o;
        if (e = e || {}, !(t = t || {}).popup && (t.popup = ((e)=>{
            const t = window.screenX + (window.innerWidth - 400) / 2, o = window.screenY + (window.innerHeight - 600) / 2;
            return window.open(e, "auth0:authorize:popup", `left=${t},top=${o},width=400,height=600,resizable,scrollbars=yes,status=1`);
        })(""), !t.popup)) throw new Error("Unable to open a popup for loginWithPopup - window.open returned `null`");
        const n = await this._prepareAuthorizeUrl(e.authorizationParams || {}, {
            response_mode: "web_message"
        }, window.location.origin);
        t.popup.location.href = n.url;
        const i = await ((e)=>new Promise((t, o)=>{
                let n;
                const i = setInterval(()=>{
                    e.popup && e.popup.closed && (clearInterval(i), clearTimeout(r), window.removeEventListener("message", n, !1), o(new $c5aa5a6035c47210$export$f1f681f0fb26bb55(e.popup)));
                }, 1e3), r = setTimeout(()=>{
                    clearInterval(i), o(new $c5aa5a6035c47210$export$ebbb83fe03f719a4(e.popup)), window.removeEventListener("message", n, !1);
                }, 1e3 * (e.timeoutInSeconds || 60));
                n = function(s) {
                    if (s.data && "authorization_response" === s.data.type) {
                        if (clearTimeout(r), clearInterval(i), window.removeEventListener("message", n, !1), e.popup.close(), s.data.response.error) return o($c5aa5a6035c47210$export$7d465be8efa67280.fromPayload(s.data.response));
                        t(s.data.response);
                    }
                }, window.addEventListener("message", n);
            }))(Object.assign(Object.assign({}, t), {
            timeoutInSeconds: t.timeoutInSeconds || this.options.authorizeTimeoutInSeconds || 60
        }));
        if (n.state !== i.state) throw new $c5aa5a6035c47210$export$7d465be8efa67280("state_mismatch", "Invalid state");
        const r = (null === (o = e.authorizationParams) || void 0 === o ? void 0 : o.organization) || this.options.authorizationParams.organization;
        await this._requestToken({
            audience: n.audience,
            scope: n.scope,
            code_verifier: n.code_verifier,
            grant_type: "authorization_code",
            code: i.code,
            redirect_uri: n.redirect_uri
        }, {
            nonceIn: n.nonce,
            organization: r
        });
    }
    async getUser() {
        var e;
        const t = await this._getIdTokenFromCache();
        return null === (e = null == t ? void 0 : t.decodedToken) || void 0 === e ? void 0 : e.user;
    }
    async getIdTokenClaims() {
        var e;
        const t = await this._getIdTokenFromCache();
        return null === (e = null == t ? void 0 : t.decodedToken) || void 0 === e ? void 0 : e.claims;
    }
    async loginWithRedirect(t = {}) {
        var o;
        const n = $c5aa5a6035c47210$var$be(t), { openUrl: i, fragment: r, appState: s } = n, a = $c5aa5a6035c47210$var$e(n, [
            "openUrl",
            "fragment",
            "appState"
        ]), c = (null === (o = a.authorizationParams) || void 0 === o ? void 0 : o.organization) || this.options.authorizationParams.organization, u = await this._prepareAuthorizeUrl(a.authorizationParams || {}), { url: h } = u, d = $c5aa5a6035c47210$var$e(u, [
            "url"
        ]);
        this.transactionManager.create(Object.assign(Object.assign(Object.assign({}, d), {
            appState: s
        }), c && {
            organization: c
        }));
        const l = r ? `${h}#${r}` : h;
        i ? await i(l) : window.location.assign(l);
    }
    async handleRedirectCallback(e = window.location.href) {
        const t = e.split("?").slice(1);
        if (0 === t.length) throw new Error("There are no query params available for parsing.");
        const { state: o, code: n, error: i, error_description: r } = ((e)=>{
            e.indexOf("#") > -1 && (e = e.substring(0, e.indexOf("#")));
            const t = new URLSearchParams(e);
            return {
                state: t.get("state"),
                code: t.get("code") || void 0,
                error: t.get("error") || void 0,
                error_description: t.get("error_description") || void 0
            };
        })(t.join("")), s = this.transactionManager.get();
        if (!s) throw new $c5aa5a6035c47210$export$7d465be8efa67280("missing_transaction", "Invalid state");
        if (this.transactionManager.remove(), i) throw new $c5aa5a6035c47210$export$cf0c46b07324e9c5(i, r || i, o, s.appState);
        if (!s.code_verifier || s.state && s.state !== o) throw new $c5aa5a6035c47210$export$7d465be8efa67280("state_mismatch", "Invalid state");
        const a = s.organization, c = s.nonce, d = s.redirect_uri;
        return await this._requestToken(Object.assign({
            audience: s.audience,
            scope: s.scope,
            code_verifier: s.code_verifier,
            grant_type: "authorization_code",
            code: n
        }, d ? {
            redirect_uri: d
        } : {}), {
            nonceIn: c,
            organization: a
        }), {
            appState: s.appState
        };
    }
    async checkSession(e) {
        if (!this.cookieStorage.get(this.isAuthenticatedCookieName)) {
            if (!this.cookieStorage.get("auth0.is.authenticated")) return;
            this.cookieStorage.save(this.isAuthenticatedCookieName, !0, {
                daysUntilExpire: this.sessionCheckExpiryDays,
                cookieDomain: this.options.cookieDomain
            }), this.cookieStorage.remove("auth0.is.authenticated");
        }
        try {
            await this.getTokenSilently(e);
        } catch (e) {}
    }
    async getTokenSilently(e = {}) {
        var t;
        const o = Object.assign(Object.assign({
            cacheMode: "on"
        }, e), {
            authorizationParams: Object.assign(Object.assign(Object.assign({}, this.options.authorizationParams), e.authorizationParams), {
                scope: $c5aa5a6035c47210$var$F(this.scope, null === (t = e.authorizationParams) || void 0 === t ? void 0 : t.scope)
            })
        }), n = await ((e, t)=>{
            let o = $c5aa5a6035c47210$var$fe[t];
            return o || (o = e().finally(()=>{
                delete $c5aa5a6035c47210$var$fe[t], o = null;
            }), $c5aa5a6035c47210$var$fe[t] = o), o;
        })(()=>this._getTokenSilently(o), `${this.options.clientId}::${o.authorizationParams.audience}::${o.authorizationParams.scope}`);
        return e.detailedResponse ? n : null == n ? void 0 : n.access_token;
    }
    async _getTokenSilently(t) {
        const { cacheMode: o } = t, n = $c5aa5a6035c47210$var$e(t, [
            "cacheMode"
        ]);
        if ("off" !== o) {
            const e = await this._getEntryFromCache({
                scope: n.authorizationParams.scope,
                audience: n.authorizationParams.audience || "default",
                clientId: this.options.clientId,
                cacheMode: o
            });
            if (e) return e;
        }
        if ("cache-only" !== o) {
            if (!await (async (e, t = 3)=>{
                for(let o = 0; o < t; o++)if (await e()) return !0;
                return !1;
            })(()=>$c5aa5a6035c47210$var$Te.acquireLock("auth0.lock.getTokenSilently", 5e3), 10)) throw new $c5aa5a6035c47210$export$66d311bf29d5c89c;
            try {
                if (window.addEventListener("pagehide", this._releaseLockOnPageHide), "off" !== o) {
                    const e = await this._getEntryFromCache({
                        scope: n.authorizationParams.scope,
                        audience: n.authorizationParams.audience || "default",
                        clientId: this.options.clientId
                    });
                    if (e) return e;
                }
                const e = this.options.useRefreshTokens ? await this._getTokenUsingRefreshToken(n) : await this._getTokenFromIFrame(n), { id_token: t, token_type: i, access_token: r, oauthTokenScope: s, expires_in: a } = e;
                return Object.assign(Object.assign({
                    id_token: t,
                    token_type: i,
                    access_token: r
                }, s ? {
                    scope: s
                } : null), {
                    expires_in: a
                });
            } finally{
                await $c5aa5a6035c47210$var$Te.releaseLock("auth0.lock.getTokenSilently"), window.removeEventListener("pagehide", this._releaseLockOnPageHide);
            }
        }
    }
    async getTokenWithPopup(e = {}, t = {}) {
        var o;
        const n = Object.assign(Object.assign({}, e), {
            authorizationParams: Object.assign(Object.assign(Object.assign({}, this.options.authorizationParams), e.authorizationParams), {
                scope: $c5aa5a6035c47210$var$F(this.scope, null === (o = e.authorizationParams) || void 0 === o ? void 0 : o.scope)
            })
        });
        t = Object.assign(Object.assign({}, $c5aa5a6035c47210$var$s), t), await this.loginWithPopup(n, t);
        return (await this.cacheManager.get(new $c5aa5a6035c47210$export$2cb47d384c8dd787({
            scope: n.authorizationParams.scope,
            audience: n.authorizationParams.audience || "default",
            clientId: this.options.clientId
        }), void 0, this.options.useMrrt)).access_token;
    }
    async isAuthenticated() {
        return !!await this.getUser();
    }
    _buildLogoutUrl(t) {
        null !== t.clientId ? t.clientId = t.clientId || this.options.clientId : delete t.clientId;
        const o = t.logoutParams || {}, { federated: n } = o, i = $c5aa5a6035c47210$var$e(o, [
            "federated"
        ]), r = n ? "&federated" : "";
        return this._url(`/v2/logout?${$c5aa5a6035c47210$var$v(Object.assign({
            clientId: t.clientId
        }, i))}`) + r;
    }
    async logout(t = {}) {
        var o;
        const n = $c5aa5a6035c47210$var$be(t), { openUrl: i } = n, r = $c5aa5a6035c47210$var$e(n, [
            "openUrl"
        ]);
        null === t.clientId ? await this.cacheManager.clear() : await this.cacheManager.clear(t.clientId || this.options.clientId), this.cookieStorage.remove(this.orgHintCookieName, {
            cookieDomain: this.options.cookieDomain
        }), this.cookieStorage.remove(this.isAuthenticatedCookieName, {
            cookieDomain: this.options.cookieDomain
        }), this.userCache.remove("@@user@@"), await (null === (o = this.dpop) || void 0 === o ? void 0 : o.clear());
        const s = this._buildLogoutUrl(r);
        i ? await i(s) : !1 !== i && window.location.assign(s);
    }
    async _getTokenFromIFrame(e) {
        const t = Object.assign(Object.assign({}, e.authorizationParams), {
            prompt: "none"
        }), o = this.cookieStorage.get(this.orgHintCookieName);
        o && !t.organization && (t.organization = o);
        const { url: n, state: i, nonce: r, code_verifier: s, redirect_uri: a, scope: c, audience: h } = await this._prepareAuthorizeUrl(t, {
            response_mode: "web_message"
        }, window.location.origin);
        try {
            if (window.crossOriginIsolated) throw new $c5aa5a6035c47210$export$7d465be8efa67280("login_required", "The application is running in a Cross-Origin Isolated context, silently retrieving a token without refresh token is not possible.");
            const o = e.timeoutInSeconds || this.options.authorizeTimeoutInSeconds;
            let l;
            try {
                l = new URL(this.domainUrl).origin;
            } catch (e) {
                l = this.domainUrl;
            }
            const p = await ((e, t, o = 60)=>new Promise((n, i)=>{
                    const r = window.document.createElement("iframe");
                    r.setAttribute("width", "0"), r.setAttribute("height", "0"), r.style.display = "none";
                    const s = ()=>{
                        window.document.body.contains(r) && (window.document.body.removeChild(r), window.removeEventListener("message", a, !1));
                    };
                    let a;
                    const c = setTimeout(()=>{
                        i(new $c5aa5a6035c47210$export$66d311bf29d5c89c), s();
                    }, 1e3 * o);
                    a = function(e) {
                        if (e.origin != t) return;
                        if (!e.data || "authorization_response" !== e.data.type) return;
                        const o = e.source;
                        o && o.close(), e.data.response.error ? i($c5aa5a6035c47210$export$7d465be8efa67280.fromPayload(e.data.response)) : n(e.data.response), clearTimeout(c), window.removeEventListener("message", a, !1), setTimeout(s, 2e3);
                    }, window.addEventListener("message", a, !1), window.document.body.appendChild(r), r.setAttribute("src", e);
                }))(n, l, o);
            if (i !== p.state) throw new $c5aa5a6035c47210$export$7d465be8efa67280("state_mismatch", "Invalid state");
            const m = await this._requestToken(Object.assign(Object.assign({}, e.authorizationParams), {
                code_verifier: s,
                code: p.code,
                grant_type: "authorization_code",
                redirect_uri: a,
                timeout: e.authorizationParams.timeout || this.httpTimeoutMs
            }), {
                nonceIn: r,
                organization: t.organization
            });
            return Object.assign(Object.assign({}, m), {
                scope: c,
                oauthTokenScope: m.scope,
                audience: h
            });
        } catch (e) {
            throw "login_required" === e.error && this.logout({
                openUrl: !1
            }), e;
        }
    }
    async _getTokenUsingRefreshToken(e) {
        const t = await this.cacheManager.get(new $c5aa5a6035c47210$export$2cb47d384c8dd787({
            scope: e.authorizationParams.scope,
            audience: e.authorizationParams.audience || "default",
            clientId: this.options.clientId
        }), void 0, this.options.useMrrt);
        if (!(t && t.refresh_token || this.worker)) {
            if (this.options.useRefreshTokensFallback) return await this._getTokenFromIFrame(e);
            throw new $c5aa5a6035c47210$export$ac1d2a00f8e0a046(e.authorizationParams.audience || "default", e.authorizationParams.scope);
        }
        const o = e.authorizationParams.redirect_uri || this.options.authorizationParams.redirect_uri || window.location.origin, n = "number" == typeof e.timeoutInSeconds ? 1e3 * e.timeoutInSeconds : null, i = ((e, t, o, n)=>{
            var i;
            if (e && o && n) {
                if (t.audience !== o) return t.scope;
                const e = n.split(" "), r = (null === (i = t.scope) || void 0 === i ? void 0 : i.split(" ")) || [], s = r.every((t)=>e.includes(t));
                return e.length >= r.length && s ? n : t.scope;
            }
            return t.scope;
        })(this.options.useMrrt, e.authorizationParams, null == t ? void 0 : t.audience, null == t ? void 0 : t.scope);
        try {
            const u = await this._requestToken(Object.assign(Object.assign(Object.assign({}, e.authorizationParams), {
                grant_type: "refresh_token",
                refresh_token: t && t.refresh_token,
                redirect_uri: o
            }), n && {
                timeout: n
            }), {
                scopesToRequest: i
            });
            if (u.refresh_token && this.options.useMrrt && (null == t ? void 0 : t.refresh_token) && await this.cacheManager.updateEntry(t.refresh_token, u.refresh_token), this.options.useMrrt) {
                if (r = null == t ? void 0 : t.audience, s = null == t ? void 0 : t.scope, a = e.authorizationParams.audience, c = e.authorizationParams.scope, r !== a || !$c5aa5a6035c47210$var$ke(c, s)) {
                    if (!$c5aa5a6035c47210$var$ke(i, u.scope)) {
                        if (this.options.useRefreshTokensFallback) return await this._getTokenFromIFrame(e);
                        throw new $c5aa5a6035c47210$export$ac1d2a00f8e0a046(e.authorizationParams.audience || "default", e.authorizationParams.scope);
                    }
                }
            }
            return Object.assign(Object.assign({}, u), {
                scope: e.authorizationParams.scope,
                oauthTokenScope: u.scope,
                audience: e.authorizationParams.audience || "default"
            });
        } catch (t) {
            if ((t.message.indexOf("Missing Refresh Token") > -1 || t.message && t.message.indexOf("invalid refresh token") > -1) && this.options.useRefreshTokensFallback) return await this._getTokenFromIFrame(e);
            throw t;
        }
        var r, s, a, c;
    }
    async _saveEntryInCache(t) {
        const { id_token: o, decodedToken: n } = t, i = $c5aa5a6035c47210$var$e(t, [
            "id_token",
            "decodedToken"
        ]);
        this.userCache.set("@@user@@", {
            id_token: o,
            decodedToken: n
        }), await this.cacheManager.setIdToken(this.options.clientId, t.id_token, t.decodedToken), await this.cacheManager.set(i);
    }
    async _getIdTokenFromCache() {
        const e = this.options.authorizationParams.audience || "default", t = await this.cacheManager.getIdToken(new $c5aa5a6035c47210$export$2cb47d384c8dd787({
            clientId: this.options.clientId,
            audience: e,
            scope: this.scope
        })), o = this.userCache.get("@@user@@");
        return t && t.id_token === (null == o ? void 0 : o.id_token) ? o : (this.userCache.set("@@user@@", t), t);
    }
    async _getEntryFromCache({ scope: e, audience: t, clientId: o, cacheMode: n }) {
        const i = await this.cacheManager.get(new $c5aa5a6035c47210$export$2cb47d384c8dd787({
            scope: e,
            audience: t,
            clientId: o
        }), 60, this.options.useMrrt, n);
        if (i && i.access_token) {
            const { token_type: e, access_token: t, oauthTokenScope: o, expires_in: n } = i, r = await this._getIdTokenFromCache();
            return r && Object.assign(Object.assign({
                id_token: r.id_token,
                token_type: e || "Bearer",
                access_token: t
            }, o ? {
                scope: o
            } : null), {
                expires_in: n
            });
        }
    }
    async _requestToken(e, t) {
        const { nonceIn: o, organization: n, scopesToRequest: i } = t || {}, r = await $c5aa5a6035c47210$var$G(Object.assign(Object.assign({
            baseUrl: this.domainUrl,
            client_id: this.options.clientId,
            auth0Client: this.options.auth0Client,
            useFormData: this.options.useFormData,
            timeout: this.httpTimeoutMs,
            useMrrt: this.options.useMrrt,
            dpop: this.dpop
        }, e), {
            scope: i || e.scope
        }), this.worker), s = await this._verifyIdToken(r.id_token, o, n);
        return await this._saveEntryInCache(Object.assign(Object.assign(Object.assign(Object.assign({}, r), {
            decodedToken: s,
            scope: e.scope,
            audience: e.audience || "default"
        }), r.scope ? {
            oauthTokenScope: r.scope
        } : null), {
            client_id: this.options.clientId
        })), this.cookieStorage.save(this.isAuthenticatedCookieName, !0, {
            daysUntilExpire: this.sessionCheckExpiryDays,
            cookieDomain: this.options.cookieDomain
        }), this._processOrgHint(n || s.claims.org_id), Object.assign(Object.assign({}, r), {
            decodedToken: s
        });
    }
    async exchangeToken(e) {
        return this._requestToken({
            grant_type: "urn:ietf:params:oauth:grant-type:token-exchange",
            subject_token: e.subject_token,
            subject_token_type: e.subject_token_type,
            scope: $c5aa5a6035c47210$var$F(e.scope, this.scope),
            audience: e.audience || this.options.authorizationParams.audience
        });
    }
    _assertDpop(e) {
        if (!e) throw new Error("`useDpop` option must be enabled before using DPoP.");
    }
    getDpopNonce(e) {
        return this._assertDpop(this.dpop), this.dpop.getNonce(e);
    }
    setDpopNonce(e, t) {
        return this._assertDpop(this.dpop), this.dpop.setNonce(e, t);
    }
    generateDpopProof(e) {
        return this._assertDpop(this.dpop), this.dpop.generateProof(e);
    }
    createFetcher(e = {}) {
        if (this.options.useDpop && !e.dpopNonceId) throw new TypeError("When `useDpop` is enabled, `dpopNonceId` must be set when calling `createFetcher()`.");
        return new $c5aa5a6035c47210$var$Se(e, {
            isDpopEnabled: ()=>!!this.options.useDpop,
            getAccessToken: (e)=>{
                var t;
                return this.getTokenSilently({
                    authorizationParams: {
                        scope: null === (t = null == e ? void 0 : e.scope) || void 0 === t ? void 0 : t.join(" "),
                        audience: null == e ? void 0 : e.audience
                    }
                });
            },
            getDpopNonce: ()=>this.getDpopNonce(e.dpopNonceId),
            setDpopNonce: (e)=>this.setDpopNonce(e),
            generateDpopProof: (e)=>this.generateDpopProof(e)
        });
    }
}
class $c5aa5a6035c47210$export$1f44aaf2ec115b54 {
}
async function $c5aa5a6035c47210$export$9fa2cfec0168886e(e) {
    const t = new $c5aa5a6035c47210$export$b50978e389d6e1d5(e);
    return await t.checkSession(), t;
}


document.addEventListener('DOMContentLoaded', function() {
    // ==== AUTH0 SETUP ====
    let auth0 = null;
    let currentUser = null;
    // Auth0 configuration
    const auth0Config = {
        domain: 'dev-7hxzk1483lfzondn.us.auth0.com',
        clientId: 'HEKjfMdnpNpvYaU6aeKh0UYweDlFxWkI',
        authorizationParams: {
            redirect_uri: window.location.origin
        }
    };
    // Initialize Auth0
    async function initAuth0() {
        try {
            auth0 = await (0, $c5aa5a6035c47210$export$9fa2cfec0168886e)(auth0Config);
            // Check if returning from redirect
            if (location.search.includes('code=')) {
                await auth0.handleRedirectCallback();
                window.history.replaceState({}, document.title, location.pathname);
            }
            // Check if user is authenticated
            const isAuthenticated = await auth0.isAuthenticated();
            if (isAuthenticated) {
                currentUser = await auth0.getUser();
                console.log('User authenticated:', currentUser);
            }
            updateAuthUI();
        } catch (error) {
            console.error('Auth0 initialization failed:', error);
            showNotification('Authentication setup failed', 'error');
        }
    }
    // Auth functions
    async function login() {
        try {
            if (!auth0) {
                showNotification('Authentication not ready, please wait...', 'error');
                return;
            }
            await auth0.loginWithRedirect();
        } catch (error) {
            console.error('Login failed:', error);
            showNotification('Login failed, please try again', 'error');
        }
    }
    async function logout() {
        try {
            if (!auth0) return;
            await auth0.logout({
                logoutParams: {
                    returnTo: window.location.origin
                }
            });
        } catch (error) {
            console.error('Logout failed:', error);
        }
    }
    // Auth UI elements
    const loginBtn = document.getElementById('loginBtn');
    const logoutBtn = document.getElementById('logoutBtn');
    function updateAuthUI() {
        const isLoggedIn = !!currentUser;
        document.body.classList.toggle('logged-in', isLoggedIn);
        document.body.classList.toggle('logged-out', !isLoggedIn);
        if (loginBtn && logoutBtn) {
            loginBtn.style.display = isLoggedIn ? 'none' : '';
            logoutBtn.style.display = isLoggedIn ? '' : 'none';
        }
        // Update user info display
        const userInfo = document.querySelector('.user-info');
        if (userInfo && currentUser) {
            userInfo.textContent = `Welcome, ${currentUser.name || currentUser.email}`;
            userInfo.style.display = '';
        } else if (userInfo) userInfo.style.display = 'none';
        loadFromLocalStorage();
        renderLeaderboard();
    }
    // Set up event listeners after Auth0 is ready
    if (loginBtn) loginBtn.addEventListener('click', login);
    if (logoutBtn) logoutBtn.addEventListener('click', logout);
    // Initialize Auth0 first
    initAuth0();
    // ==== REST OF YOUR EXISTING CODE ====
    // Leaderboard elements
    const leaderboardEl = document.getElementById('leaderboard');
    const leaderboardBtns = document.querySelectorAll('.leaderboard-period');
    const screenshotInput = document.getElementById('screenshotUpload');
    const submitScreenshotBtn = document.getElementById('submitScreenshot');
    // Enhanced Journal elements
    const screenshotModeBtn = document.getElementById('screenshotModeBtn');
    const manualModeBtn = document.getElementById('manualModeBtn');
    const screenshotMode = document.getElementById('screenshotMode');
    const manualMode = document.getElementById('manualMode');
    const tradeScreenshot = document.getElementById('tradeScreenshot');
    const processScreenshot = document.getElementById('processScreenshot');
    const enhancedTradeForm = document.getElementById('enhancedTradeForm');
    // ==== ENHANCED JOURNAL MODE SWITCHING ====
    if (screenshotModeBtn && manualModeBtn) {
        screenshotModeBtn.addEventListener('click', function() {
            switchToScreenshotMode();
        });
        manualModeBtn.addEventListener('click', function() {
            switchToManualMode();
        });
    }
    function switchToScreenshotMode() {
        if (screenshotModeBtn) screenshotModeBtn.classList.add('active');
        if (manualModeBtn) manualModeBtn.classList.remove('active');
        if (screenshotMode) screenshotMode.classList.remove('hidden');
        if (manualMode) manualMode.classList.add('hidden');
    }
    function switchToManualMode() {
        if (manualModeBtn) manualModeBtn.classList.add('active');
        if (screenshotModeBtn) screenshotModeBtn.classList.remove('active');
        if (manualMode) manualMode.classList.remove('hidden');
        if (screenshotMode) screenshotMode.classList.add('hidden');
    }
    // ==== TRADE TYPE SWITCHING ====
    const tradeTypeButtons = document.querySelectorAll('.trade-type-btn');
    let currentTradeType = 'stock';
    tradeTypeButtons.forEach((btn)=>{
        btn.addEventListener('click', function() {
            // Update active button
            tradeTypeButtons.forEach((b)=>b.classList.remove('active'));
            this.classList.add('active');
            // Hide all form fields
            document.querySelectorAll('.trade-fields').forEach((field)=>field.classList.add('hidden'));
            // Show selected form fields
            currentTradeType = this.dataset.type;
            const selectedFields = document.querySelector(`.${currentTradeType}-fields`);
            if (selectedFields) selectedFields.classList.remove('hidden');
        });
    });
    // ==== SCREENSHOT PROCESSING ====
    if (processScreenshot && tradeScreenshot) processScreenshot.addEventListener('click', function() {
        const file = tradeScreenshot.files[0];
        if (!file) {
            showNotification('Please select a screenshot file', 'error');
            return;
        }
        processTradeScreenshot(file);
    });
    // Enhanced screenshot processing with Netlify Functions + Google Vision API
    async function processTradeScreenshot(imageFile) {
        try {
            showNotification('Processing screenshot with Google Vision API...', 'info');
            // Create form data
            const formData = new FormData();
            formData.append('image', imageFile);
            // Call your Netlify function
            const response = await fetch('/.netlify/functions/process-screenshot', {
                method: 'POST',
                body: formData
            });
            if (!response.ok) {
                const errorText = await response.text();
                throw new Error(`HTTP error! status: ${response.status}, message: ${errorText}`);
            }
            const result = await response.json();
            if (result.success) {
                console.log('OCR Result:', result);
                showNotification(`OCR completed with ${result.confidence}% confidence`, 'success');
                displayExtractedDataWithCorrection(result.tradeData, result.extractedText);
            } else throw new Error(result.error || 'OCR processing failed');
        } catch (error) {
            console.error('OCR Error:', error);
            showNotification('Error processing screenshot: ' + error.message, 'error');
            // Fallback to manual entry
            switchToManualMode();
        }
    }
    // Enhanced display of extracted data with correction interface
    function displayExtractedDataWithCorrection(tradeData, rawText) {
        const extractedDataDiv = document.getElementById('extractedData');
        const tradeInfoDiv = document.getElementById('extractedTradeInfo');
        if (!extractedDataDiv || !tradeInfoDiv) {
            console.error('Extracted data elements not found');
            return;
        }
        // Create correction interface
        tradeInfoDiv.innerHTML = `
            <div class="extracted-trade-correction">
                <div class="raw-text-section">
                    <h4>Raw OCR Text:</h4>
                    <div class="raw-text">${rawText}</div>
                </div>
                <div class="correction-form">
                    <h4>Extracted Trade Details (Please verify and correct):</h4>
                    <div class="correction-row">
                        <label>Symbol:</label>
                        <input type="text" id="corrected-symbol" value="${tradeData.symbol || ''}" placeholder="e.g., AAPL">
                    </div>
                    <div class="correction-row">
                        <label>Trade Type:</label>
                        <select id="corrected-type">
                            <option value="long" ${tradeData.type === 'long' ? 'selected' : ''}>Long</option>
                            <option value="short" ${tradeData.type === 'short' ? 'selected' : ''}>Short</option>
                        </select>
                    </div>
                    <div class="correction-row">
                        <label>Entry Price:</label>
                        <input type="number" id="corrected-entry" value="${tradeData.entryPrice || ''}" placeholder="0.00" step="0.01">
                    </div>
                    <div class="correction-row">
                        <label>Exit Price:</label>
                        <input type="number" id="corrected-exit" value="${tradeData.exitPrice || ''}" placeholder="0.00" step="0.01">
                    </div>
                    <div class="correction-row">
                        <label>Position Size:</label>
                        <input type="number" id="corrected-size" value="${tradeData.positionSize || ''}" placeholder="100" step="1">
                    </div>
                    <div class="correction-row">
                        <label>P&L:</label>
                        <input type="number" id="corrected-pnl" value="${tradeData.pnl || ''}" placeholder="0.00" step="0.01">
                    </div>
                </div>
            </div>
        `;
        extractedDataDiv.classList.remove('hidden');
        // Setup correction buttons
        const confirmBtn = document.getElementById('confirmExtractedTrade');
        const editBtn = document.getElementById('editExtractedTrade');
        if (confirmBtn) confirmBtn.onclick = function() {
            const correctedData = {
                symbol: document.getElementById('corrected-symbol').value,
                type: document.getElementById('corrected-type').value,
                entryPrice: parseFloat(document.getElementById('corrected-entry').value),
                exitPrice: parseFloat(document.getElementById('corrected-exit').value),
                positionSize: parseInt(document.getElementById('corrected-size').value),
                pnl: parseFloat(document.getElementById('corrected-pnl').value)
            };
            addTradeFromExtractedData(correctedData);
            extractedDataDiv.classList.add('hidden');
        };
        if (editBtn) editBtn.onclick = function() {
            const correctedData = {
                symbol: document.getElementById('corrected-symbol').value,
                type: document.getElementById('corrected-type').value,
                entryPrice: document.getElementById('corrected-entry').value,
                exitPrice: document.getElementById('corrected-exit').value,
                positionSize: document.getElementById('corrected-size').value,
                pnl: document.getElementById('corrected-pnl').value
            };
            fillManualFormWithData(correctedData);
            switchToManualMode();
            extractedDataDiv.classList.add('hidden');
        };
    }
    function addTradeFromExtractedData(data) {
        const trade = {
            id: Date.now(),
            symbol: data.symbol,
            type: data.type,
            entryPrice: data.entryPrice,
            exitPrice: data.exitPrice,
            positionSize: data.positionSize,
            pnl: data.pnl,
            timestamp: new Date().toISOString(),
            source: 'screenshot'
        };
        addTrade(trade);
        showNotification('Trade added successfully from screenshot!', 'success');
    }
    function fillManualFormWithData(data) {
        // Fill the manual form with extracted data
        const symbolField = document.getElementById('symbol');
        const sideField = document.getElementById('side');
        const entryField = document.getElementById('entryPrice');
        const exitField = document.getElementById('exitPrice');
        const quantityField = document.getElementById('quantity');
        if (symbolField) symbolField.value = data.symbol || '';
        if (sideField) sideField.value = data.type || '';
        if (entryField) entryField.value = data.entryPrice || '';
        if (exitField) exitField.value = data.exitPrice || '';
        if (quantityField) quantityField.value = data.positionSize || '';
        // Recalculate P&L
        calculateRealTimePnL();
    }
    // ==== REAL-TIME P&L CALCULATION ====
    function calculateRealTimePnL() {
        const entryPrice = parseFloat(document.getElementById('entryPrice')?.value) || 0;
        const exitPrice = parseFloat(document.getElementById('exitPrice')?.value) || 0;
        const quantity = parseInt(document.getElementById('quantity')?.value) || 0;
        const side = document.getElementById('side')?.value;
        let pnl = 0;
        if (entryPrice && exitPrice && quantity) {
            if (side === 'long') pnl = (exitPrice - entryPrice) * quantity;
            else if (side === 'short') pnl = (entryPrice - exitPrice) * quantity;
        }
        const pnlDisplay = document.getElementById('calculatedPnL');
        if (pnlDisplay) {
            pnlDisplay.textContent = `$${pnl.toFixed(2)}`;
            pnlDisplay.className = `calculated-pnl ${pnl >= 0 ? 'positive' : 'negative'}`;
        }
        return pnl;
    }
    // Add event listeners for real-time calculation
    [
        'entryPrice',
        'exitPrice',
        'quantity',
        'side'
    ].forEach((id)=>{
        const element = document.getElementById(id);
        if (element) {
            element.addEventListener('input', calculateRealTimePnL);
            element.addEventListener('change', calculateRealTimePnL);
        }
    });
    // ==== OPTIONS P&L CALCULATION ====
    function calculateOptionsPnL() {
        const entryPremium = parseFloat(document.getElementById('entryPremium')?.value) || 0;
        const exitPremium = parseFloat(document.getElementById('exitPremium')?.value) || 0;
        const contracts = parseInt(document.getElementById('contracts')?.value) || 0;
        const side = document.getElementById('optionSide')?.value;
        let pnl = 0;
        if (entryPremium && exitPremium && contracts) {
            if (side === 'buy') pnl = (exitPremium - entryPremium) * contracts * 100;
            else if (side === 'sell') pnl = (entryPremium - exitPremium) * contracts * 100;
        }
        const pnlDisplay = document.getElementById('optionsCalculatedPnL');
        if (pnlDisplay) {
            pnlDisplay.textContent = `$${pnl.toFixed(2)}`;
            pnlDisplay.className = `calculated-pnl ${pnl >= 0 ? 'positive' : 'negative'}`;
        }
        return pnl;
    }
    // Add event listeners for options calculation
    [
        'entryPremium',
        'exitPremium',
        'contracts',
        'optionSide'
    ].forEach((id)=>{
        const element = document.getElementById(id);
        if (element) {
            element.addEventListener('input', calculateOptionsPnL);
            element.addEventListener('change', calculateOptionsPnL);
        }
    });
    // ==== FUTURES P&L CALCULATION ====
    function calculateFuturesPnL() {
        const entryPrice = parseFloat(document.getElementById('futuresEntryPrice')?.value) || 0;
        const exitPrice = parseFloat(document.getElementById('futuresExitPrice')?.value) || 0;
        const contracts = parseInt(document.getElementById('futuresContracts')?.value) || 0;
        const side = document.getElementById('futuresSide')?.value;
        const symbol = document.getElementById('futuresSymbol')?.value?.toUpperCase();
        // Contract multipliers
        const multipliers = {
            'ES': 50,
            'MES': 5,
            'NQ': 20,
            'MNQ': 2,
            'YM': 5,
            'MYM': 0.5,
            'RTY': 50,
            'M2K': 5,
            'CL': 1000,
            'GC': 100,
            'SI': 5000,
            'ZN': 1000
        };
        const multiplier = multipliers[symbol] || 50; // Default to ES multiplier
        let pnl = 0;
        if (entryPrice && exitPrice && contracts) {
            const pointDifference = side === 'long' ? exitPrice - entryPrice : entryPrice - exitPrice;
            pnl = pointDifference * contracts * multiplier;
        }
        const pnlDisplay = document.getElementById('futuresCalculatedPnL');
        if (pnlDisplay) {
            pnlDisplay.textContent = `$${pnl.toFixed(2)}`;
            pnlDisplay.className = `calculated-pnl ${pnl >= 0 ? 'positive' : 'negative'}`;
        }
        return pnl;
    }
    // Add event listeners for futures calculation
    [
        'futuresEntryPrice',
        'futuresExitPrice',
        'futuresContracts',
        'futuresSide',
        'futuresSymbol'
    ].forEach((id)=>{
        const element = document.getElementById(id);
        if (element) {
            element.addEventListener('input', calculateFuturesPnL);
            element.addEventListener('change', calculateFuturesPnL);
        }
    });
    // ==== CRYPTO P&L CALCULATION ====
    function calculateCryptoPnL() {
        const entryPrice = parseFloat(document.getElementById('cryptoEntryPrice')?.value) || 0;
        const exitPrice = parseFloat(document.getElementById('cryptoExitPrice')?.value) || 0;
        const quantity = parseFloat(document.getElementById('cryptoQuantity')?.value) || 0;
        const side = document.getElementById('cryptoSide')?.value;
        let pnl = 0;
        if (entryPrice && exitPrice && quantity) {
            if (side === 'long') pnl = (exitPrice - entryPrice) * quantity;
            else if (side === 'short') pnl = (entryPrice - exitPrice) * quantity;
        }
        const pnlDisplay = document.getElementById('cryptoCalculatedPnL');
        if (pnlDisplay) {
            pnlDisplay.textContent = `$${pnl.toFixed(2)}`;
            pnlDisplay.className = `calculated-pnl ${pnl >= 0 ? 'positive' : 'negative'}`;
        }
        return pnl;
    }
    // Add event listeners for crypto calculation
    [
        'cryptoEntryPrice',
        'cryptoExitPrice',
        'cryptoQuantity',
        'cryptoSide'
    ].forEach((id)=>{
        const element = document.getElementById(id);
        if (element) {
            element.addEventListener('input', calculateCryptoPnL);
            element.addEventListener('change', calculateCryptoPnL);
        }
    });
    // ==== DATA STORAGE ====
    let trades = [];
    let leaderboardData = JSON.parse(localStorage.getItem('leaderboardData') || '{"monthly":[],"weekly":[]}');
    let currentPeriod = 'monthly';
    function loadFromLocalStorage() {
        // Only load data if user is authenticated
        if (!currentUser) {
            trades = [];
            return;
        }
        const today = new Date().toDateString();
        const savedTrades = localStorage.getItem(`trades_${today}_${currentUser.sub}`);
        if (savedTrades) trades = JSON.parse(savedTrades);
        else trades = [];
        updateTradesDisplay();
        updateStatistics();
        updateCapitalDisplay();
        updateDailyProgress();
    }
    function saveToLocalStorage() {
        if (!currentUser) return;
        const today = new Date().toDateString();
        localStorage.setItem(`trades_${today}_${currentUser.sub}`, JSON.stringify(trades));
        localStorage.setItem('leaderboardData', JSON.stringify(leaderboardData));
        updateLeaderboard();
    }
    // ==== ENHANCED TRADE FORM SUBMISSION ====
    if (enhancedTradeForm) enhancedTradeForm.addEventListener('submit', function(e) {
        e.preventDefault();
        if (!currentUser) {
            showNotification('Please log in to add trades', 'error');
            return;
        }
        let trade = {};
        // Get trade data based on current trade type
        switch(currentTradeType){
            case 'stock':
                trade = {
                    id: Date.now(),
                    type: currentTradeType,
                    symbol: document.getElementById('symbol').value.toUpperCase(),
                    side: document.getElementById('side').value,
                    entryPrice: parseFloat(document.getElementById('entryPrice').value),
                    exitPrice: parseFloat(document.getElementById('exitPrice').value),
                    quantity: parseInt(document.getElementById('quantity').value),
                    pnl: calculateRealTimePnL(),
                    timestamp: new Date().toISOString()
                };
                break;
            case 'options':
                trade = {
                    id: Date.now(),
                    type: currentTradeType,
                    symbol: document.getElementById('optionsSymbol').value.toUpperCase(),
                    optionType: document.getElementById('optionType').value,
                    strike: parseFloat(document.getElementById('strike').value),
                    expiration: document.getElementById('expiration').value,
                    side: document.getElementById('optionSide').value,
                    contracts: parseInt(document.getElementById('contracts').value),
                    entryPremium: parseFloat(document.getElementById('entryPremium').value),
                    exitPremium: parseFloat(document.getElementById('exitPremium').value),
                    pnl: calculateOptionsPnL(),
                    timestamp: new Date().toISOString()
                };
                break;
            case 'futures':
                trade = {
                    id: Date.now(),
                    type: currentTradeType,
                    symbol: document.getElementById('futuresSymbol').value.toUpperCase(),
                    side: document.getElementById('futuresSide').value,
                    contracts: parseInt(document.getElementById('futuresContracts').value),
                    entryPrice: parseFloat(document.getElementById('futuresEntryPrice').value),
                    exitPrice: parseFloat(document.getElementById('futuresExitPrice').value),
                    pnl: calculateFuturesPnL(),
                    timestamp: new Date().toISOString()
                };
                break;
            case 'crypto':
                trade = {
                    id: Date.now(),
                    type: currentTradeType,
                    symbol: document.getElementById('cryptoSymbol').value.toUpperCase(),
                    side: document.getElementById('cryptoSide').value,
                    quantity: parseFloat(document.getElementById('cryptoQuantity').value),
                    entryPrice: parseFloat(document.getElementById('cryptoEntryPrice').value),
                    exitPrice: parseFloat(document.getElementById('cryptoExitPrice').value),
                    pnl: calculateCryptoPnL(),
                    timestamp: new Date().toISOString()
                };
                break;
        }
        // Validate trade
        if (!trade.symbol || !trade.pnl && trade.pnl !== 0) {
            showNotification('Please fill in all required fields', 'error');
            return;
        }
        addTrade(trade);
        enhancedTradeForm.reset();
        // Reset to first trade type and show stock fields
        document.querySelector('.trade-type-btn[data-type="stock"]').click();
        showNotification('Trade added successfully!', 'success');
    });
    function addTrade(trade) {
        trades.push(trade);
        updateTradesDisplay();
        updateStatistics();
        updateCapitalDisplay();
        updateDailyProgress();
        saveToLocalStorage();
        // Check daily goal
        checkDailyGoal();
    }
    // ==== TRADES DISPLAY ====
    function updateTradesDisplay() {
        const tradesList = document.getElementById('tradesList');
        if (!tradesList) return;
        if (trades.length === 0) {
            tradesList.innerHTML = '<p class="no-trades">No trades recorded yet</p>';
            return;
        }
        let tradesHTML = '';
        trades.forEach((trade, index)=>{
            const time = new Date(trade.timestamp).toLocaleTimeString();
            const pnlClass = trade.pnl >= 0 ? 'positive' : 'negative';
            let tradeDetails = '';
            switch(trade.type){
                case 'stock':
                    tradeDetails = `${trade.quantity} shares @ $${trade.entryPrice} \u{2192} $${trade.exitPrice}`;
                    break;
                case 'options':
                    tradeDetails = `${trade.contracts} contracts ${trade.optionType} $${trade.strike} @ $${trade.entryPremium} \u{2192} $${trade.exitPremium}`;
                    break;
                case 'futures':
                    tradeDetails = `${trade.contracts} contracts @ $${trade.entryPrice} \u{2192} $${trade.exitPrice}`;
                    break;
                case 'crypto':
                    tradeDetails = `${trade.quantity} units @ $${trade.entryPrice} \u{2192} $${trade.exitPrice}`;
                    break;
            }
            tradesHTML += `
                <div class="trade-item">
                    <div class="trade-header">
                        <span class="trade-symbol">${trade.symbol} (${trade.type})</span>
                        <span class="trade-side ${trade.side}">${trade.side?.toUpperCase()}</span>
                        <span class="trade-pnl ${pnlClass}">${trade.pnl >= 0 ? '+' : ''}$${trade.pnl.toFixed(2)}</span>
                        <span class="trade-time">${time}</span>
                    </div>
                    <div class="trade-details">${tradeDetails}</div>
                    <div class="trade-actions">
                        <button class="btn btn--sm btn--outline" onclick="editTrade(${index})">Edit</button>
                        <button class="btn btn--sm btn--danger" onclick="deleteTrade(${index})">Delete</button>
                    </div>
                </div>
            `;
        });
        tradesList.innerHTML = tradesHTML;
    }
    // Make functions global for onclick handlers
    window.editTrade = function(index) {
        const trade = trades[index];
        showNotification('Edit functionality coming soon!', 'info');
    };
    window.deleteTrade = function(index) {
        if (confirm('Are you sure you want to delete this trade?')) {
            trades.splice(index, 1);
            updateTradesDisplay();
            updateStatistics();
            updateCapitalDisplay();
            updateDailyProgress();
            saveToLocalStorage();
            showNotification('Trade deleted', 'success');
        }
    };
    // ==== STATISTICS ====
    function updateStatistics() {
        const totalTradesEl = document.getElementById('totalTrades');
        const winRateEl = document.getElementById('winRate');
        const bestTradeEl = document.getElementById('bestTrade');
        const worstTradeEl = document.getElementById('worstTrade');
        if (!totalTradesEl) return;
        const totalTrades = trades.length;
        const winningTrades = trades.filter((t)=>t.pnl > 0).length;
        const winRate = totalTrades > 0 ? (winningTrades / totalTrades * 100).toFixed(1) : 0;
        const pnls = trades.map((t)=>t.pnl);
        const bestTrade = pnls.length > 0 ? Math.max(...pnls) : 0;
        const worstTrade = pnls.length > 0 ? Math.min(...pnls) : 0;
        totalTradesEl.textContent = totalTrades;
        winRateEl.textContent = `${winRate}%`;
        bestTradeEl.textContent = `$${bestTrade.toFixed(2)}`;
        worstTradeEl.textContent = `$${worstTrade.toFixed(2)}`;
    }
    // ==== DAILY PROGRESS ====
    function updateDailyProgress() {
        const dailyPnLEl = document.getElementById('dailyPnL');
        const progressFillEl = document.getElementById('progressFill');
        const dailyGoalInput = document.getElementById('dailyGoal');
        if (!dailyPnLEl) return;
        const dailyPnL = trades.reduce((sum, trade)=>sum + trade.pnl, 0);
        const dailyGoal = parseFloat(dailyGoalInput?.value) || 0;
        dailyPnLEl.textContent = `${dailyPnL >= 0 ? '+' : ''}$${dailyPnL.toFixed(2)}`;
        dailyPnLEl.className = `summary-value ${dailyPnL >= 0 ? 'positive' : 'negative'}`;
        if (dailyGoal > 0 && progressFillEl) {
            const progress = Math.min(dailyPnL / dailyGoal * 100, 100);
            progressFillEl.style.width = `${Math.max(progress, 0)}%`;
            if (progress >= 100) progressFillEl.classList.add('goal-achieved');
            else progressFillEl.classList.remove('goal-achieved');
        }
    }
    function checkDailyGoal() {
        const dailyGoalInput = document.getElementById('dailyGoal');
        const dailyGoal = parseFloat(dailyGoalInput?.value) || 0;
        if (dailyGoal > 0) {
            const dailyPnL = trades.reduce((sum, trade)=>sum + trade.pnl, 0);
            if (dailyPnL >= dailyGoal) showCelebrationModal(dailyGoal, dailyPnL);
        }
    }
    function showCelebrationModal(goal, achieved) {
        const modal = document.getElementById('celebrationModal');
        const goalSpan = document.getElementById('celebrationGoal');
        const achievedSpan = document.getElementById('celebrationAchieved');
        if (modal && goalSpan && achievedSpan) {
            goalSpan.textContent = goal.toFixed(2);
            achievedSpan.textContent = achieved.toFixed(2);
            modal.classList.remove('hidden');
        }
    }
    // ==== CAPITAL MANAGEMENT ====
    function updateCapitalDisplay() {
        const originalCapitalEl = document.getElementById('originalCapitalDisplay');
        const totalProfitsEl = document.getElementById('totalProfitsDisplay');
        const newCapitalEl = document.getElementById('newCapitalDisplay');
        const profitAdditionEl = document.getElementById('profitAddition');
        const profitAmountEl = document.getElementById('profitAmount');
        const updateBtn = document.getElementById('updateCapitalFromProfits');
        if (!originalCapitalEl) return;
        const capital = parseFloat(document.getElementById('capital')?.value) || 0;
        const totalPnL = trades.reduce((sum, trade)=>sum + trade.pnl, 0);
        const newCapital = capital + totalPnL;
        originalCapitalEl.textContent = `$${capital.toLocaleString()}`;
        totalProfitsEl.textContent = `${totalPnL >= 0 ? '+' : ''}$${totalPnL.toFixed(2)}`;
        totalProfitsEl.className = `capital-value ${totalPnL >= 0 ? 'positive' : 'negative'}`;
        newCapitalEl.textContent = `$${newCapital.toLocaleString()}`;
        if (totalPnL !== 0) {
            profitAmountEl.textContent = `${totalPnL >= 0 ? '+' : ''}$${totalPnL.toFixed(2)}`;
            profitAdditionEl.style.display = '';
            if (updateBtn) updateBtn.disabled = false;
        } else {
            profitAdditionEl.style.display = 'none';
            if (updateBtn) updateBtn.disabled = true;
        }
    }
    // ==== RISK CALCULATOR ====
    const calculateRiskBtn = document.getElementById('calculateRisk');
    const riskButtons = document.querySelectorAll('.risk-btn');
    let selectedRisk = null;
    riskButtons.forEach((btn)=>{
        btn.addEventListener('click', function() {
            riskButtons.forEach((b)=>b.classList.remove('active'));
            this.classList.add('active');
            selectedRisk = this.dataset.risk;
        });
    });
    if (calculateRiskBtn) calculateRiskBtn.addEventListener('click', function() {
        const capital = parseFloat(document.getElementById('capital').value);
        if (!capital || capital <= 0) {
            showNotification('Please enter a valid trading capital amount', 'error');
            return;
        }
        if (!selectedRisk) {
            showNotification('Please select a risk tolerance level', 'error');
            return;
        }
        const riskPercentages = {
            safe: 0.015,
            risky: 0.025,
            highRisk: 0.04
        };
        const riskPercent = riskPercentages[selectedRisk];
        const riskPerTrade = capital * riskPercent;
        const maxDailyLoss = capital * (riskPercent * 3);
        document.getElementById('riskPerTrade').textContent = `$${riskPerTrade.toFixed(2)}`;
        document.getElementById('maxDailyLoss').textContent = `$${maxDailyLoss.toFixed(2)}`;
        document.getElementById('riskAmount').textContent = `$${riskPerTrade.toFixed(2)}`;
        document.getElementById('riskReward').textContent = '1:2 minimum';
        document.getElementById('riskResults').classList.remove('hidden');
        // Update capital displays
        updateCapitalDisplay();
    });
    // ==== LEADERBOARD ====
    function renderLeaderboard() {
        if (!currentUser) return;
        const period = currentPeriod;
        const data = leaderboardData[period] || [];
        // Add current user's performance
        const todaysPnL = trades.reduce((sum, trade)=>sum + trade.pnl, 0);
        const userEntry = {
            name: currentUser.name || currentUser.email,
            pnl: todaysPnL,
            verified: false
        };
        // Update or add user entry
        const existingIndex = data.findIndex((entry)=>entry.name === userEntry.name);
        if (existingIndex >= 0) data[existingIndex].pnl = userEntry.pnl;
        else data.push(userEntry);
        // Sort by P&L
        data.sort((a, b)=>b.pnl - a.pnl);
        const leaderboardEl = document.getElementById('leaderboard');
        if (leaderboardEl) {
            let html = '<div class="leaderboard-list">';
            data.slice(0, 10).forEach((entry, index)=>{
                const rank = index + 1;
                const isCurrentUser = entry.name === userEntry.name;
                html += `
                    <div class="leaderboard-item ${isCurrentUser ? 'current-user' : ''}">
                        <span class="rank">#${rank}</span>
                        <span class="name">${entry.name} ${entry.verified ? "\u2705" : ''}</span>
                        <span class="pnl ${entry.pnl >= 0 ? 'positive' : 'negative'}">
                            ${entry.pnl >= 0 ? '+' : ''}$${entry.pnl.toFixed(2)}
                        </span>
                    </div>
                `;
            });
            html += '</div>';
            leaderboardEl.innerHTML = html;
        }
        // Update leaderboard data
        leaderboardData[period] = data;
        localStorage.setItem('leaderboardData', JSON.stringify(leaderboardData));
    }
    function updateLeaderboard() {
        renderLeaderboard();
    }
    // Leaderboard period switching
    leaderboardBtns.forEach((btn)=>{
        btn.addEventListener('click', function() {
            leaderboardBtns.forEach((b)=>b.classList.remove('active'));
            this.classList.add('active');
            currentPeriod = this.dataset.period;
            renderLeaderboard();
        });
    });
    // ==== SCREENSHOT UPLOAD FOR VERIFICATION ====
    if (submitScreenshotBtn && screenshotInput) submitScreenshotBtn.addEventListener('click', function() {
        const file = screenshotInput.files[0];
        if (!file) {
            showNotification('Please select a screenshot', 'error');
            return;
        }
        showNotification('Processing verification screenshot...', 'info');
        setTimeout(()=>{
            showNotification("P&L verified successfully! \u2705", 'success');
            const period = currentPeriod;
            const data = leaderboardData[period] || [];
            const userEntry = data.find((entry)=>entry.name === (currentUser.name || currentUser.email));
            if (userEntry) {
                userEntry.verified = true;
                renderLeaderboard();
            }
        }, 2000);
    });
    // ==== UTILITY FUNCTIONS ====
    function showNotification(message, type = 'info') {
        let notification = document.getElementById('notification');
        if (!notification) {
            notification = document.createElement('div');
            notification.id = 'notification';
            notification.className = 'notification';
            document.body.appendChild(notification);
        }
        notification.textContent = message;
        notification.className = `notification ${type} show`;
        setTimeout(()=>{
            notification.classList.remove('show');
        }, 3000);
    }
    // ==== EXPORT FUNCTIONALITY ====
    const exportBtn = document.getElementById('exportTrades');
    if (exportBtn) exportBtn.addEventListener('click', function() {
        if (trades.length === 0) {
            showNotification('No trades to export', 'error');
            return;
        }
        const csvContent = generateCSV(trades);
        downloadCSV(csvContent, `trades_${new Date().toDateString()}.csv`);
        showNotification('Trades exported successfully!', 'success');
    });
    function generateCSV(trades) {
        const headers = [
            'Timestamp',
            'Symbol',
            'Type',
            'Side',
            'Entry Price',
            'Exit Price',
            'Quantity/Contracts',
            'P&L'
        ];
        const rows = trades.map((trade)=>[
                new Date(trade.timestamp).toLocaleString(),
                trade.symbol,
                trade.type,
                trade.side || '',
                trade.entryPrice || trade.entryPremium || '',
                trade.exitPrice || trade.exitPremium || '',
                trade.quantity || trade.contracts || '',
                trade.pnl.toFixed(2)
            ]);
        return [
            headers,
            ...rows
        ].map((row)=>row.join(',')).join('\n');
    }
    function downloadCSV(content, filename) {
        const blob = new Blob([
            content
        ], {
            type: 'text/csv'
        });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
    }
    // ==== CLEAR ALL TRADES ====
    const clearAllBtn = document.getElementById('clearAllTrades');
    if (clearAllBtn) clearAllBtn.addEventListener('click', function() {
        if (confirm('Are you sure you want to clear all trades? This cannot be undone.')) {
            trades = [];
            updateTradesDisplay();
            updateStatistics();
            updateCapitalDisplay();
            updateDailyProgress();
            saveToLocalStorage();
            showNotification('All trades cleared', 'success');
        }
    });
    // ==== MODAL HANDLERS ====
    const celebrationModal = document.getElementById('celebrationModal');
    const continueTradingBtn = document.getElementById('continueTradingBtn');
    const setNewGoalBtn = document.getElementById('setNewGoalBtn');
    if (continueTradingBtn) continueTradingBtn.addEventListener('click', function() {
        celebrationModal.classList.add('hidden');
    });
    if (setNewGoalBtn) setNewGoalBtn.addEventListener('click', function() {
        celebrationModal.classList.add('hidden');
        document.getElementById('dailyGoal').focus();
    });
    // Close modals when clicking outside
    document.addEventListener('click', function(e) {
        if (e.target.classList.contains('modal-overlay')) e.target.parentElement.classList.add('hidden');
    });
    // ==== CAPITAL MANAGEMENT BUTTONS ====
    const updateCapitalBtn = document.getElementById('updateCapitalFromProfits');
    const resetCapitalBtn = document.getElementById('resetToOriginal');
    if (updateCapitalBtn) updateCapitalBtn.addEventListener('click', function() {
        const capitalInput = document.getElementById('capital');
        const currentCapital = parseFloat(capitalInput.value) || 0;
        const totalPnL = trades.reduce((sum, trade)=>sum + trade.pnl, 0);
        const newCapital = currentCapital + totalPnL;
        if (confirm(`Update capital from $${currentCapital.toLocaleString()} to $${newCapital.toLocaleString()}?`)) {
            capitalInput.value = newCapital;
            showNotification('Capital updated successfully!', 'success');
            updateCapitalDisplay();
        }
    });
    if (resetCapitalBtn) resetCapitalBtn.addEventListener('click', function() {
        const originalCapital = parseFloat(document.getElementById('capital').value) || 0;
        if (confirm(`Reset capital to original amount of $${originalCapital.toLocaleString()}?`)) {
            updateCapitalDisplay();
            showNotification('Capital reset to original amount', 'success');
        }
    });
    // ==== CLEAR FORM BUTTON ====
    const clearFormBtn = document.getElementById('clearEnhancedForm');
    if (clearFormBtn) clearFormBtn.addEventListener('click', function() {
        enhancedTradeForm.reset();
        document.querySelectorAll('.calculated-pnl').forEach((el)=>{
            el.textContent = '$0.00';
            el.className = 'calculated-pnl';
        });
    });
    // ==== DAILY GOAL PERSISTENCE ====
    const dailyGoalInput = document.getElementById('dailyGoal');
    if (dailyGoalInput) {
        const savedGoal = localStorage.getItem('dailyGoal');
        if (savedGoal) dailyGoalInput.value = savedGoal;
        dailyGoalInput.addEventListener('change', function() {
            localStorage.setItem('dailyGoal', this.value);
            updateDailyProgress();
        });
    }
    // Initial load
    setTimeout(()=>{
        updateDailyProgress();
        renderLeaderboard();
    }, 100);
});


//# sourceMappingURL=repo.b098e6fe.js.map
